{
  "absences.actions.add": "+ Assenza",
  "absences.delete.confirm": "Eliminare davvero questa assenza?",
  "absences.empty": "Questa organizzazione non ha rapporti di lavoro in corso.",
  "absences.errors.loadFailed": "Impossibile caricare il calendario delle assenze.",
  "absences.form.add": "Aggiungi",
  "absences.form.choosePerson": "Scegli una persona …",
  "absences.form.close": "Chiudi",
  "absences.form.createTitle": "Nuova assenza",
  "absences.form.editTitle": "Modifica assenza",
  "absences.form.fields.dateFrom": "Dal",
  "absences.form.fields.dateTo": "Al",
  "absences.form.fields.note": "Nota",
  "absences.form.fields.person": "Persona",
  "absences.form.fields.type": "Tipo",
  "absences.form.generated": "Questa assenza è stata scritta dal regolamento in base alle timbrature. Non è modificabile qui: la prossima elaborazione sovrascriverebbe la modifica.",
  "absences.form.problems.isGenerated": "Questa assenza è stata scritta dal regolamento e non può essere modificata a mano.",
  "absences.form.problems.overlaps": "Questa persona ha già un'assenza in questo periodo.",
  "absences.form.problems.overlapsGenerated": "In questi giorni esiste già un’assenza scritta dal regolamento in base alle timbrature.",
  "absences.form.problems.saveFailed": "Impossibile salvare l'assenza.",
  "absences.form.saving": "Salvataggio …",
  "absences.form.validation.dateFromRequired": "Indica il primo giorno.",
  "absences.form.validation.dateToRequired": "Indica l'ultimo giorno.",
  "absences.form.validation.noteMaxLength": "La nota può contenere al massimo 500 caratteri.",
  "absences.form.validation.personRequired": "Scegli una persona.",
  "absences.form.validation.rangeReversed": "«Al» non può precedere «Dal».",
  "absences.form.viewTitle": "Assenza",
  "absences.generated": "scritta dal regolamento in base alle timbrature",
  "absences.hint": "Clicca su un giorno di una riga per inserire un'assenza, clicca su una barra per aprirla. Ctrl + rotellina per lo zoom.",
  "access.permission.group.skill": "Competenze",
  "access.permission.skill.admin": "Gestire le competenze",
  "access.permission.skill.admin.description": "Creare, modificare ed eliminare il catalogo delle competenze.",
  "auth.callback.backToSignIn": "Torna all'accesso",
  "auth.callback.errors.authFailed": "Autenticazione non riuscita. Riprova.",
  "auth.callback.errors.exchangeFailed": "Scambio non riuscito ({{status}}).",
  "auth.callback.errors.missingCode": "Codice di autorizzazione mancante.",
  "auth.callback.errors.serverNotConfirmed": "Il server non ha confermato l'autenticazione.",
  "auth.callback.errors.sessionAfterSignIn": "Impossibile stabilire la sessione dopo l'accesso.",
  "auth.callback.errors.sessionFailed": "Impossibile stabilire la sessione. Accedi di nuovo.",
  "auth.callback.exchanging": "Scambio del codice di autorizzazione…",
  "auth.callback.subtitle": "Attendi mentre colleghiamo il tuo account.",
  "auth.callback.success": "Operazione riuscita. Reindirizzamento…",
  "auth.callback.title": "Completamento accesso",
  "auth.forgotPassword.errors.invalidToken": "This reset link is invalid or expired.",
  "auth.forgotPassword.errors.passwordRequirements": "Your new password does not meet the requirements.",
  "auth.forgotPassword.errors.requestFailed": "Could not send reset email. Please try again.",
  "auth.forgotPassword.errors.resetFailed": "Non è stato possibile reimpostare la password. Riprova.",
  "auth.forgotPassword.request.form.emailLabel": "Email",
  "auth.forgotPassword.request.form.emailPlaceholder": "you@company.com",
  "auth.forgotPassword.request.sending": "Sending…",
  "auth.forgotPassword.request.signInPrompt": "Remember your password?",
  "auth.forgotPassword.request.submit": "Send reset link",
  "auth.forgotPassword.request.subtitle": "We will email you a link to choose a new password.",
  "auth.forgotPassword.request.title": "Reset your password",
  "auth.forgotPassword.reset.form.confirmPasswordLabel": "Confirm password",
  "auth.forgotPassword.reset.form.confirmPasswordPlaceholder": "Confirm password",
  "auth.forgotPassword.reset.form.emailLabel": "Email",
  "auth.forgotPassword.reset.form.newPasswordLabel": "New password",
  "auth.forgotPassword.reset.form.newPasswordPlaceholder": "New password",
  "auth.forgotPassword.reset.signInPrompt": "Done?",
  "auth.forgotPassword.reset.submit": "Update password",
  "auth.forgotPassword.reset.submitting": "Updating…",
  "auth.forgotPassword.reset.subtitle": "Enter and confirm your new password.",
  "auth.forgotPassword.reset.title": "Choose a new password",
  "auth.forgotPassword.signInLink": "Sign in",
  "auth.forgotPassword.success.emailSent": "If an account exists, we sent a reset link to your email.",
  "auth.forgotPassword.success.passwordUpdated": "Password updated. Redirecting to sign in…",
  "auth.forgotPassword.validation.confirmPasswordRequired": "Please confirm your password",
  "auth.forgotPassword.validation.passwordMinLength": "Password must be at least 8 characters",
  "auth.forgotPassword.validation.passwordMismatch": "Passwords do not match",
  "auth.forgotPassword.validation.passwordRequired": "Password is required",
  "auth.login.credentials.invalid": "Invalid email or password.",
  "auth.login.credentials.unexpectedError": "Something went wrong. Please try again.",
  "auth.login.error.title": "Sign-in failed",
  "auth.login.errors.Callback": "There was a problem with the callback.",
  "auth.login.errors.CredentialsSignin": "Sign in failed. Check the details you provided are correct.",
  "auth.login.errors.default": "Authentication failed. Please try again.",
  "auth.login.errors.EmailCreateAccount": "Could not create account.",
  "auth.login.errors.emailNotVerified": "Verify your email before signing in. Check your inbox for the confirmation link.",
  "auth.login.errors.EmailSignin": "Check your email for the sign in link.",
  "auth.login.errors.invite_required": "You need an invitation to sign up. Ask an administrator of your organization to send you an invite link.",
  "auth.login.errors.inviteRequired": "You need an invitation to sign up. Ask an administrator of your organization to send you an invite link.",
  "auth.login.errors.OAuthAccountNotLinked": "Account not linked. Please sign in with the same account you used originally.",
  "auth.login.errors.OAuthCallback": "Sign-in with your provider failed. Please try again.",
  "auth.login.errors.OAuthCreateAccount": "Could not create account.",
  "auth.login.errors.OAuthSignin": "There was a problem signing you in via OAuth.",
  "auth.login.errors.pending_approval": "Your account was created but is not active yet. An administrator must approve your access before you can sign in.",
  "auth.login.errors.pendingApproval": "Your account was created but is not active yet. An administrator must approve your access before you can sign in.",
  "auth.login.errors.Signin": "There was a problem signing you in.",
  "auth.login.forgotPassword": "Forgot password?",
  "auth.login.form.emailLabel": "Email",
  "auth.login.form.emailPlaceholder": "you@company.com",
  "auth.login.form.passwordLabel": "Password",
  "auth.login.form.passwordPlaceholder": "••••••••",
  "auth.login.noMethodsConfigured": "No sign-in methods are configured.",
  "auth.login.oauth.continueWith": "Or continue with",
  "auth.login.oauth.custom": "Sign in",
  "auth.login.oauth.discord": "Discord",
  "auth.login.oauth.google": "Google",
  "auth.login.oauth.microsoft": "Microsoft",
  "auth.login.pageSubtitle": "Usa la tua e-mail o un account collegato per continuare.",
  "auth.login.pageTitle": "Accedi",
  "auth.login.pendingApproval.title": "Account pending activation",
  "auth.login.rateLimit.message": "Try again in {{seconds}} seconds.",
  "auth.login.rateLimit.title": "Too many attempts",
  "auth.login.rememberMe": "Remember me",
  "auth.login.signIn": "Sign in",
  "auth.login.signingIn": "Signing in…",
  "auth.login.signUp.link": "Create an account",
  "auth.login.signUp.prompt": "New here?",
  "auth.login.validation.passwordMinLength": "Password must be at least 6 characters",
  "auth.login.validation.passwordRequired": "Password is required",
  "auth.logout": "Esci",
  "auth.password.errors.notAvailable": "Password change is not available.",
  "auth.register.createAccount": "Create account",
  "auth.register.creatingAccount": "Creating account…",
  "auth.register.errors.emailAlreadyExists": "An account with this email already exists.",
  "auth.register.errors.failedGeneric": "Registration failed.",
  "auth.register.errors.failedRetry": "Registration failed. Please try again.",
  "auth.register.errors.fillRequired": "Please fill in all required fields.",
  "auth.register.errors.inviteRequired": "You need an invitation to sign up. Ask an administrator of your organization to send you an invite link.",
  "auth.register.errors.notAvailable": "Registration is not available.",
  "auth.register.form.emailLabel": "Email",
  "auth.register.form.emailPlaceholder": "you@company.com",
  "auth.register.form.nameLabel": "Full name",
  "auth.register.form.namePlaceholder": "Jane Doe",
  "auth.register.form.passwordLabel": "Password",
  "auth.register.form.passwordPlaceholder": "Create a strong password",
  "auth.register.passwordHint": "At least 8 characters with uppercase, lowercase, a number, and a symbol.",
  "auth.register.passwordUnavailable.lead": "Registration is not available.",
  "auth.register.passwordUnavailable.signInLink": "Sign in",
  "auth.register.signIn.link": "Sign in",
  "auth.register.signIn.prompt": "Already have an account?",
  "auth.register.subtitle": "Get started with Workforce in a few steps.",
  "auth.register.title": "Create your account",
  "auth.register.validation.nameMaxLength": "Name is too long",
  "auth.register.validation.nameRequired": "Name is required",
  "auth.register.validation.passwordMaxLength": "Password is too long",
  "auth.register.validation.passwordMinLength": "Password must be at least 8 characters",
  "auth.register.validation.passwordPattern": "Password does not meet complexity requirements",
  "auth.register.validation.passwordRequired": "Password is required",
  "auth.resendVerification.failed": "We could not send a new verification email. Please try again.",
  "auth.verifyEmail.failed": "We could not verify your email address. The link may have expired.",
  "common.actions.cancel": "Cancel",
  "common.actions.delete": "Delete",
  "common.actions.edit": "Edit",
  "common.actions.reset": "Reset",
  "common.actions.save": "Save",
  "common.form.optional": "optional",
  "common.form.validation.companyMaxLength": "Company must be 255 characters or less",
  "common.form.validation.emailInvalid": "Enter a valid email address",
  "common.form.validation.emailMaxLength": "Email is too long",
  "common.form.validation.emailRequired": "Email is required",
  "common.form.validation.firstNameMaxLength100": "First name must be 100 characters or less",
  "common.form.validation.firstNameRequired": "First name is required",
  "common.form.validation.lastNameMaxLength100": "Last name must be 100 characters or less",
  "common.form.validation.lastNameRequired": "Last name is required",
  "common.form.validation.maxLength1000": "Must be 1000 characters or less",
  "common.form.validation.nameMaxLength": "Name is too long",
  "common.form.validation.nameRequired": "Name is required",
  "common.form.validation.phoneMaxLength": "Phone must be 30 characters or less",
  "common.form.validation.titleMaxLength10": "Title must be 10 characters or less",
  "common.form.validation.typeRequired": "Type is required",
  "common.loading": "Loading…",
  "common.messages.confirm": "Are you sure?",
  "common.messages.deleteConfirm": "Are you sure you want to delete this item?",
  "common.messages.error": "An error occurred",
  "common.messages.success": "Operation completed successfully",
  "contacts.actions.create": "Create contact",
  "contacts.delete.description": "This action cannot be undone.",
  "contacts.details.contactInfo": "Contact Information",
  "contacts.details.fields.company": "Company",
  "contacts.details.fields.createdAt": "Created At",
  "contacts.details.fields.updatedAt": "Updated At",
  "contacts.details.professionalInfo": "Professional Information",
  "contacts.details.tags": "Tags",
  "contacts.errors.personAlreadyExists": "A contact with this email already exists.",
  "contacts.form.createTitle": "Create contact",
  "contacts.form.editTitle": "Edit contact",
  "contacts.form.fields.additionalEmail": "Additional Email",
  "contacts.form.fields.email": "Email",
  "contacts.form.fields.firstName": "First Name",
  "contacts.form.fields.lastName": "Last Name",
  "contacts.form.fields.phone": "Phone",
  "contacts.form.fields.tags": "Tags",
  "contacts.form.fields.title": "Title",
  "contacts.form.fields.type": "Type",
  "contacts.form.help.tags": "Select one or more tags to classify this contact.",
  "contacts.form.placeholders.additionalEmail": "Enter additional email (optional)",
  "contacts.form.placeholders.email": "Enter email address",
  "contacts.form.placeholders.firstName": "Enter first name",
  "contacts.form.placeholders.lastName": "Enter last name",
  "contacts.form.placeholders.phone": "Enter phone number",
  "contacts.form.placeholders.title": "Select title",
  "contacts.form.sections.contact": "Contact details",
  "contacts.form.sections.name": "Name",
  "contacts.tags.host": "Host",
  "contacts.types.contractor": "Contractor",
  "contacts.types.employee": "Employee",
  "contacts.types.guest": "Guest",
  "contacts.types.resident": "Resident",
  "contacts.types.visitor": "Visitor",
  "costCenter.actions.create": "Crea centro di costo",
  "costCenter.actions.hide": "Nascondi qui",
  "costCenter.actions.override": "Sovrascrivi qui",
  "costCenter.actions.restore": "Rimuovi la versione locale (torna ereditata)",
  "costCenter.delete.confirm": "Vuoi davvero eliminare questo centro di costo?",
  "costCenter.errors.loadFailed": "Impossibile caricare i centri di costo.",
  "costCenter.form.createTitle": "Nuovo centro di costo",
  "costCenter.form.editTitle": "Modifica centro di costo",
  "costCenter.form.fields.department": "Area (opzionale)",
  "costCenter.form.fields.isInactive": "Attualmente non valido",
  "costCenter.form.fields.name": "Denominazione",
  "costCenter.form.fields.number": "Numero centro di costo",
  "costCenter.form.fields.validFrom": "Valido da",
  "costCenter.form.fields.validTo": "Valido fino a",
  "costCenter.form.overrideTitle": "Sovrascrivi centro di costo",
  "costCenter.form.saving": "Salvataggio …",
  "costCenter.form.validation.departmentMaxLength": "L'area è troppo lunga.",
  "costCenter.form.validation.nameMaxLength": "La denominazione è troppo lunga.",
  "costCenter.form.validation.nameRequired": "La denominazione è obbligatoria.",
  "costCenter.form.validation.numberMaxLength": "Il numero del centro di costo è troppo lungo.",
  "costCenter.form.validation.numberRequired": "Il numero del centro di costo è obbligatorio.",
  "costCenter.form.validation.validFromRequired": "Valido da è obbligatorio.",
  "costCenter.list.empty": "Nessun centro di costo presente.",
  "costCenter.list.inactive": "non valido",
  "costCenter.list.inheritedFrom": "ereditato da {{unit}}",
  "costCenter.list.overridden": "sovrascritto",
  "dashboard.noPerson.description": "Your account is not linked to a person in any organization yet, so there is nothing to show here. Ask an administrator to send you an invite link.",
  "dashboard.noPerson.title": "No organization assigned",
  "dashboard.persons.grid.description": "Browse and manage persons in the selected organization.",
  "dashboard.scaffold.dummyDescription": "Pagina segnaposto",
  "dashboard.scaffold.gridPlaceholder": "Segnaposto ag-grid",
  "dashboard.time.accounts.balanceDummy": "Dati di esempio per il saldo mensile",
  "dashboard.time.accounts.chartPlaceholder": "Segnaposto ag-chart — {{count}} punti dati",
  "dashboard.time.accounts.chartPlaceholderSimple": "Segnaposto ag-chart",
  "dashboard.time.accounts.historyTitle": "Storico conto ore",
  "dashboard.time.accounts.hoursDummy": "Dati di esempio per le ore lavorate",
  "dashboard.time.accounts.rangeLabel": "Periodo",
  "dsl.editor.activate": "Attiva",
  "dsl.editor.activating": "Attivazione…",
  "dsl.editor.active": "Attiva",
  "dsl.editor.compileError.MULTIPLE_PIPELINES": "Ci sono più blocchi rule configuration. Tenerne esattamente uno e spostare tutte le regole al suo interno.",
  "dsl.editor.compileError.PIPELINE_MISSING": "Manca il blocco rule configuration, quindi non è possibile eseguire nulla. Aggiungerne uno dalla categoria Structure.",
  "dsl.editor.compileError.title": "Salvato, ma senza regole eseguibili",
  "dsl.editor.context.appliesTo": "Vale per i modelli orari:",
  "dsl.editor.context.appliesToAll": "Vale per tutti i modelli orario di questa unità.",
  "dsl.editor.context.appliesToAllHint": "La fase 1 non indica alcun modello orario. Un insieme di regole della stessa unità che ne indica uno esplicitamente prevale per quel modello.",
  "dsl.editor.context.governsNobody": "Questo set di regole non vale per nessuno.",
  "dsl.editor.context.governsNobodyHint": "La fase 1 è vuota, quindi nessun contratto segue questo insieme di regole. Inserisci «applies to time model» e salva: all’inizio vale per tutti i modelli orario.",
  "dsl.editor.context.shadows": "Sostituisce il set di regole con lo stesso codice di {{unit}}.",
  "dsl.editor.draft": "Bozza — non ancora in esecuzione",
  "dsl.editor.draftRunning": "Bozza — è in esecuzione la versione {{running}}",
  "dsl.editor.loadFailed": "Impossibile caricare il set di regole.",
  "dsl.editor.noVersionYet": "Non ancora salvato",
  "dsl.editor.referenceIssues": "Questo set di regole fa riferimento a dati anagrafici non più presenti in questa unità organizzativa:",
  "dsl.editor.masterDataIssues": "Questa versione legge dati anagrafici che non possono essere letti così come memorizzati. Potrà essere attivata dopo la correzione:",
  "dsl.editor.masterDataIssue.UNKNOWN_ENTITY": "entità sconosciuta",
  "dsl.editor.masterDataIssue.UNKNOWN_FIELD": "campo sconosciuto",
  "dsl.editor.masterDataIssue.UNKNOWN_DAY": "giorno sconosciuto",
  "dsl.editor.masterDataIssue.FIELD_OF_OTHER_ENTITY": "il campo non appartiene a questa entità",
  "dsl.editor.masterDataIssue.NO_PREVIOUS_DAY": "per questo campo non esiste un giorno precedente",
  "dsl.editor.masterDataIssue.CHANGED_ON_LOAD": "memorizzato, ma modificato al caricamento – controllare il blocco e salvare di nuovo",
  "dsl.editor.referenceKind.account": "Conto",
  "dsl.editor.referenceKind.bookingType": "Tipo di timbratura",
  "dsl.editor.referenceKind.timeType": "Tipo di tempo",
  "dsl.editor.save": "Salva set di regole",
  "dsl.editor.saveConflict.allTimeModels": "Il set di regole «{{ruleSet}}» ({{ruleSetCode}}) di questa unità organizzativa vale già per tutti i modelli orari. Solo un set di regole per unità può farlo: indica qui un modello orario specifico e salva di nuovo.",
  "dsl.editor.saveConflict.timeModel": "Il modello orario {{workSchedule}} è già assegnato al set di regole «{{ruleSet}}» ({{ruleSetCode}}) di questa unità organizzativa. Un modello orario può appartenere a un solo set di regole per unità: rimuovilo dall’assegnazione qui o lì e salva di nuovo.",
  "dsl.editor.saveConflict.title": "Non salvato",
  "dsl.editor.saving": "Salvataggio …",
  "dsl.editor.title": "Set di regole",
  "dsl.editor.version": "Versione {{version}}",
  "dsl.masterData.fields.entryDate": "Data di assunzione",
  "dsl.masterData.fields.exitDate": "Data di cessazione",
  "dsl.masterData.fields.sicknessReferenceDate": "Inizio anno di malattia",
  "dsl.masterData.fields.sicknessServiceDurationDays": "Malattia: anzianità rilevante (giorni)",
  "dsl.masterData.fields.sicknessServiceStartDate": "Malattia: inizio dell’anzianità computabile",
  "dsl.masterData.fields.vacationReferenceDate": "Inizio anno di ferie",
  "dsl.masterData.fields.vacationServiceDurationDays": "Ferie: anzianità rilevante (giorni)",
  "dsl.masterData.fields.vacationServiceStartDate": "Ferie: inizio dell’anzianità computabile",
  "dsl.masterData.fields.vacationWaitingPeriodMonths": "Periodo di attesa prima del primo diritto alle ferie (mesi)",
  "dsl.masterData.fields.vacationYearType": "Anno di ferie",
  "dsl.masterData.fields.weeklyTargetMinutes": "Orario settimanale dal modello orario (minuti)",
  "dsl.masterData.fields.workDaysPerWeek": "Giorni lavorativi a settimana",
  "dsl.ruleSets.actions.create": "Nuovo set di regole",
  "dsl.ruleSets.create.title": "Nuovo set di regole",
  "dsl.ruleSets.delete.confirm": "Eliminare questo regolamento e tutte le sue versioni?",
  "dsl.ruleSets.empty": "Questa unità non ha un set di regole proprio. Vale quello dell’unità superiore più vicina.",
  "dsl.ruleSets.fields.code": "Codice",
  "dsl.ruleSets.fields.codeHint": "La chiave su cui agisce l’ereditarietà. Maiuscole, senza spazi — non modificabile in seguito.",
  "dsl.ruleSets.fields.name": "Denominazione",
  "dsl.ruleSets.loadFailed": "Non è stato possibile caricare i set di regole.",
  "dsl.ruleSets.neverSaved": "non ancora salvato",
  "dsl.ruleSets.problems.codePattern": "Il codice può contenere solo A–Z, 0–9 e trattini bassi.",
  "dsl.ruleSets.problems.codeRequired": "Inserisci un codice.",
  "dsl.ruleSets.problems.codeTaken": "Questa unità ha già un set di regole con questo codice.",
  "dsl.ruleSets.problems.nameRequired": "Inserisci una denominazione.",
  "dsl.ruleSets.validation.codePattern": "Il codice può contenere solo A–Z, 0–9 e trattini bassi.",
  "dsl.status.edit": "Modifica set di regole",
  "dsl.status.lastChanged": "Ultima modifica",
  "dsl.status.loadFailed": "Impossibile caricare lo stato del set di regole.",
  "dsl.status.noRuleSet": "Nessun set di regole definito per questa unità organizzativa.",
  "dsl.status.version": "Versione {{version}}",
  "employment.entity.absence": "Assenza",
  "employment.entity.group.time": "Tempo",
  "employments.create": "Nuovo rapporto di lavoro",
  "employments.empty": "Questa unità non ha ancora rapporti di lavoro.",
  "employments.errors.loadFailed": "Non è stato possibile caricare i rapporti di lavoro.",
  "employments.fields.employmentNumber": "Numero",
  "employments.fields.employmentRelationship": "Categoria di dipendente",
  "employments.fields.employmentType": "Tipo di contratto",
  "employments.fields.entryDate": "Assunzione",
  "employments.fields.exitDate": "Cessazione",
  "employments.fields.payGrade": "Gruppo salariale",
  "employments.fields.payGradeLevel": "Livello salariale",
  "employments.fields.payScale": "Contratto collettivo",
  "employments.fields.person": "Persona",
  "employments.fields.sicknessCreditedFrom": "Malattia: servizio conteggiato da",
  "employments.fields.sicknessCreditedMonths": "Malattia: mesi riconosciuti",
  "employments.fields.sicknessReferenceDate": "Inizio anno di malattia",
  "employments.fields.vacationCreditedFrom": "Ferie: servizio conteggiato da",
  "employments.fields.vacationCreditedMonths": "Ferie: mesi riconosciuti",
  "employments.fields.vacationReferenceDate": "Inizio anno di ferie",
  "employments.fields.validFrom": "Valido dal",
  "employments.fields.validTo": "Valido fino al",
  "employments.fields.weeklyHours": "Ore settimanali",
  "employments.fields.workSchedule": "Modello orario",
  "employments.form.choose": "Seleziona…",
  "employments.form.choosePerson": "Seleziona una persona…",
  "employments.form.chooseWorkSchedule": "Seleziona un modello orario…",
  "employments.form.createTitle": "Nuovo rapporto di lavoro",
  "employments.form.creditedHint": "Indicare il servizio precedente per ciascuno scopo come data oppure come mesi, non entrambi. Vuoto significa nessun riconoscimento.",
  "employments.form.editTitle": "Modifica rapporto di lavoro",
  "employments.form.none": "— nessuno —",
  "employments.form.noWorkSchedules": "Questa unità organizzativa non ha ancora modelli orari. Creane uno in Gestione del tempo → Modelli orari.",
  "employments.form.personFixed": "La persona e l’unità organizzativa non possono essere modificate su un rapporto esistente.",
  "employments.form.problems.employmentNumber": "Inserisci un numero del rapporto di lavoro.",
  "employments.form.problems.employmentType": "Seleziona un tipo di contratto.",
  "employments.form.problems.entryDate": "Inserisci una data di assunzione.",
  "employments.form.problems.exitDateBeforeEntry": "La data di cessazione precede quella di assunzione.",
  "employments.form.problems.notAnEmployer": "I rapporti di lavoro appartengono a un’azienda. Questa unità organizzativa non lo è: seleziona un’azienda nell’elenco.",
  "employments.form.problems.organizationUnitId": "Nessuna unità organizzativa indicata. Inizia dall’elenco.",
  "employments.form.problems.personId": "Seleziona una persona.",
  "employments.form.problems.saveFailed": "Salvataggio non riuscito. Riprova.",
  "employments.form.problems.validFrom": "Inserisci l’inizio della validità.",
  "employments.form.problems.validToBeforeValidFrom": "La validità termina prima di iniziare.",
  "employments.form.problems.weeklyHours": "Le ore settimanali devono essere un numero, ad esempio 38,5.",
  "employments.form.problems.workScheduleId": "Seleziona un modello orario. Senza di esso nulla pianifica le giornate di questa persona.",
  "employments.list.noMatch": "Nessun rapporto di lavoro corrisponde alla ricerca.",
  "employments.list.search": "Cerca per numero o nome",
  "employments.onlyOnCompany": "I rapporti di lavoro si creano su un’azienda. Selezionane una qui sopra.",
  "employments.organizationUnit": "Unità organizzativa",
  "nav.chart.month.apr": "Apr",
  "nav.chart.month.aug": "Ago",
  "nav.chart.month.dec": "Dic",
  "nav.chart.month.feb": "Feb",
  "nav.chart.month.jan": "Gen",
  "nav.chart.month.jul": "Lug",
  "nav.chart.month.jun": "Giu",
  "nav.chart.month.mar": "Mar",
  "nav.chart.month.may": "Mag",
  "nav.chart.month.nov": "Nov",
  "nav.chart.month.oct": "Ott",
  "nav.chart.month.sep": "Set",
  "nav.chart.range.month": "Ore di questo mese",
  "nav.chart.range.week": "Ore di questa settimana",
  "nav.chart.range.year": "Ore di quest'anno",
  "nav.chart.week.kw1": "Sett. 1",
  "nav.chart.week.kw2": "Sett. 2",
  "nav.chart.week.kw3": "Sett. 3",
  "nav.chart.week.kw4": "Sett. 4",
  "nav.chart.weekday.fri": "Ven",
  "nav.chart.weekday.mon": "Lun",
  "nav.chart.weekday.sat": "Sab",
  "nav.chart.weekday.sun": "Dom",
  "nav.chart.weekday.thu": "Gio",
  "nav.chart.weekday.tue": "Mar",
  "nav.chart.weekday.wed": "Mer",
  "nav.dashboard.title": "Dashboard",
  "nav.mobile.close": "Chiudi",
  "nav.mobile.closeMenu": "Chiudi menu",
  "nav.mobile.mainNavigation": "Navigazione principale",
  "nav.mobile.menu": "Menu",
  "nav.mobile.more": "Altro",
  "nav.mobile.moreSubtitle": "Altre sezioni",
  "nav.primary.home": "Home",
  "nav.primary.orgChart": "Organigramma",
  "nav.primary.payScale": "Contratto collettivo",
  "nav.primary.payScale.short": "CCNL",
  "nav.primary.persons": "Persone",
  "nav.primary.plan": "Piano",
  "nav.primary.settings": "Impostazioni",
  "nav.primary.time": "Tempo",
  "nav.secondary.payScale.grades": "Gruppi salariali",
  "nav.secondary.payScale.levels": "Livelli salariali",
  "nav.secondary.payScale.scales": "Contratti collettivi",
  "nav.secondary.persons.grid": "Elenco persone",
  "nav.secondary.persons.profile": "Profilo",
  "nav.secondary.persons.settings": "Impostazioni",
  "nav.secondary.persons.skills": "Competenze",
  "nav.secondary.plan.overview": "Panoramica",
  "nav.secondary.plan.schedule": "Piano turni",
  "nav.secondary.settings.accounts": "Utenti",
  "nav.secondary.settings.general": "Impostazioni",
  "nav.secondary.settings.organizations": "Organizzazioni",
  "nav.secondary.settings.profile": "Profilo",
  "nav.secondary.settings.roles": "Ruoli",
  "nav.secondary.settings.textCatalog": "Catalogo testi",
  "nav.secondary.time.absences": "Assenze",
  "nav.secondary.time.accounts": "Conti ore",
  "nav.secondary.time.runs": "Avvia elaborazione",
  "nav.secondary.time.runsLog": "Protocollo esecuzioni",
  "nav.secondary.time.tracking": "Rilevazione tempo",
  "nav.topbar.apps": "App",
  "nav.topbar.brand": "Workforce",
  "nav.topbar.home": "Home Workforce",
  "nav.topbar.language": "Lingua",
  "nav.topbar.openMenu": "Apri menu",
  "organigram.delete.confirm": "Elimina",
  "organigram.delete.messageAssignment": "Vuoi davvero rimuovere questa persona dalla posizione?",
  "organigram.delete.messageOe": "Vuoi davvero eliminare questa unità organizzativa? L'operazione non può essere annullata.",
  "organigram.delete.messagePosition": "Vuoi davvero eliminare questa posizione? L'operazione non può essere annullata.",
  "organigram.delete.messageStation": "Vuoi davvero eliminare questa stazione? L'operazione non può essere annullata.",
  "organigram.delete.title": "Conferma eliminazione",
  "organigram.empty": "Nessuna struttura organizzativa disponibile.",
  "organigram.errors.childrenNotAllowed": "Le unità sottostanti non potrebbero stare sotto il nuovo tipo. Spostarle prima, poi cambiare il tipo.",
  "organigram.errors.companyEmploys": "A questa unità sono legati rapporti di lavoro: deve restare un’azienda.",
  "organigram.errors.deleteFailed": "Eliminazione non riuscita.",
  "organigram.errors.loadFailed": "Impossibile caricare l'organigramma.",
  "organigram.errors.moveFailed": "Spostamento non riuscito.",
  "organigram.errors.parentTakesNoChildren": "Sotto questa unità non stanno altre unità.",
  "organigram.errors.positionsNotAllowed": "A questa unità sono legate delle posizioni, che il nuovo tipo non prevede.",
  "organigram.errors.rootTakesOne": "L'organizzazione ha già la sua azienda. Le altre unità vanno al di sotto.",
  "organigram.errors.saveFailed": "Salvataggio non riuscito.",
  "organigram.errors.stationsNotAllowed": "A questa unità sono legate delle stazioni, che il nuovo tipo non prevede.",
  "organigram.errors.typeNotAllowedUnderParent": "Questo tipo di unità non può stare lì. La struttura è: radice → azienda → centro di profitto → reparto.",
  "organigram.node.add": "Aggiungi",
  "organigram.node.addOe": "Unità organizzativa",
  "organigram.node.addOeTooltip": "Aggiungi unità organizzativa",
  "organigram.node.addPerson": "Assegna persona",
  "organigram.node.addPosition": "Posizione",
  "organigram.node.addStation": "Stazione",
  "organigram.node.deleteOe": "Elimina unità organizzativa",
  "organigram.node.deletePosition": "Elimina posizione",
  "organigram.node.deleteStation": "Elimina stazione",
  "organigram.node.editPosition": "Modifica posizione",
  "organigram.node.editStation": "Modifica stazione",
  "organigram.node.locked": "Bloccato (entità giuridica)",
  "organigram.node.settings": "Configurazione",
  "organigram.node.viewPermissions": "View permissions",
  "organigram.oe.positionOne": "posizione",
  "organigram.oe.positionOther": "posizioni",
  "organigram.oe.stationOne": "stazione",
  "organigram.oe.stationOther": "stazioni",
  "organigram.oeType.company": "Azienda",
  "organigram.oeType.department": "Reparto",
  "organigram.oeType.organization": "Organizzazione (radice)",
  "organigram.oeType.profitCenter": "Centro di profitto",
  "organigram.panel.actions.cancel": "Annulla",
  "organigram.panel.actions.delete": "Elimina",
  "organigram.panel.actions.save": "Salva",
  "organigram.panel.actions.saving": "Salvataggio …",
  "organigram.panel.errors.loadingPermissions": "Could not load permissions",
  "organigram.panel.fields.countryCode": "Paese",
  "organigram.panel.fields.countryCodeNone": "Nessun paese",
  "organigram.panel.fields.description": "Descrizione (opzionale)",
  "organigram.panel.fields.legalName": "Nome legale (opzionale)",
  "organigram.panel.fields.name": "Nome",
  "organigram.panel.fields.person": "Persona",
  "organigram.panel.fields.personPlaceholder": "Seleziona …",
  "organigram.panel.fields.primary": "Come posizione principale",
  "organigram.panel.fields.responsiblePerson": "Responsabile",
  "organigram.panel.fields.responsiblePersonChosen": "Scelta:",
  "organigram.panel.fields.responsiblePersonClear": "rimuovi",
  "organigram.panel.fields.responsiblePersonNone": "Nessuna persona trovata.",
  "organigram.panel.fields.responsiblePersonSearch": "Cerca una persona …",
  "organigram.panel.fields.roles": "Ruoli",
  "organigram.panel.fields.timezone": "Fuso orario",
  "organigram.panel.fields.timezoneHint": "Determina cosa intende una regola con un orario come «non prima delle 08:30».",
  "organigram.panel.fields.timezoneInherited": "Come l’unità superiore",
  "organigram.panel.fields.type": "Tipo",
  "organigram.panel.fields.vacationInherited": "— dall’unità superiore —",
  "organigram.panel.fields.vacationWaitingPeriodHint": "Lasciare vuoto per ereditare il valore dall'unità superiore. 0 significa diritto dal primo giorno.",
  "organigram.panel.fields.vacationWaitingPeriodMonths": "Periodo di attesa prima del primo diritto (mesi)",
  "organigram.panel.fields.vacationYearType": "Anno di ferie",
  "organigram.panel.noPersons": "Nessuna persona trovata in questa organizzazione.",
  "organigram.panel.noRoles": "Nessun ruolo disponibile.",
  "organigram.panel.permissions.all": "Tutti",
  "organigram.panel.removeRole": "Rimuovi ruolo",
  "organigram.panel.rolePlaceholder": "Aggiungi ruolo …",
  "organigram.panel.settings.accounts": "Conti",
  "organigram.panel.settings.backToSections": "Torna alla panoramica",
  "organigram.panel.settings.bookingTypes": "Tipi di timbratura",
  "organigram.panel.settings.costCenters": "Centri di costo",
  "organigram.panel.settings.dayPrograms": "Programmi giornalieri",
  "organigram.panel.settings.employments": "Rapporti di lavoro",
  "organigram.panel.settings.groups.costAccounting": "Contabilità dei costi",
  "organigram.panel.settings.groups.employment": "Rapporti di lavoro",
  "organigram.panel.settings.groups.hints.costAccounting": "Centri di costo su cui viene registrato il tempo",
  "organigram.panel.settings.groups.hints.employment": "Chi è assunto da questa azienda",
  "organigram.panel.settings.groups.hints.timeManagement": "Tipi di timbratura, tipi di tempo, conti e regole",
  "organigram.panel.settings.groups.hints.unit": "Denominazione, tipo, fuso orario e orario centrale",
  "organigram.panel.settings.groups.timeManagement": "Gestione del tempo",
  "organigram.panel.settings.hints.accounts": "Saldi come orario flessibile e straordinari",
  "organigram.panel.settings.hints.bookingTypes": "Per quali motivi si può timbrare",
  "organigram.panel.settings.hints.costCenters": "Su quali centri di costo viene registrato il tempo",
  "organigram.panel.settings.hints.dayPrograms": "Come si svolge una giornata pianificata",
  "organigram.panel.settings.hints.employments": "I contratti dei dipendenti di questa azienda",
  "organigram.panel.settings.hints.publicHolidays": "Quali festività valgono e se intere o a metà",
  "organigram.panel.settings.hints.rules": "Le regole che trasformano le timbrature in saldi",
  "organigram.panel.settings.hints.timeTypes": "Come viene valutato il tempo registrato",
  "organigram.panel.settings.hints.workSchedules": "Quale programma giornaliero segue ogni giorno della settimana",
  "organigram.panel.settings.inherited": "Questo reparto eredita la sua configurazione. Viene gestita sull’azienda o sull’organizzazione superiore.",
  "organigram.panel.settings.publicHolidays": "Festività",
  "organigram.panel.settings.root": "Configurazione",
  "organigram.panel.settings.rules": "Set di regole",
  "organigram.panel.settings.timeTypes": "Tipi di tempo",
  "organigram.panel.settings.workSchedules": "Modelli orari",
  "organigram.panel.title.assignPerson": "Assegna persona",
  "organigram.panel.title.createOe": "Aggiungi unità organizzativa",
  "organigram.panel.title.createPosition": "Aggiungi posizione",
  "organigram.panel.title.createStation": "Aggiungi stazione",
  "organigram.panel.title.editOe": "Modifica unità organizzativa",
  "organigram.panel.title.editPosition": "Modifica posizione",
  "organigram.panel.title.editStation": "Modifica stazione",
  "organigram.panel.title.settings": "Configurazione",
  "organigram.panel.title.viewPermissions": "Diritti della posizione",
  "organigram.panel.vacationYear.calendarYear": "Anno solare",
  "organigram.panel.vacationYear.workYear": "Anno lavorativo",
  "organigram.panel.validation.descriptionMaxLength": "La descrizione è troppo lunga.",
  "organigram.panel.validation.legalNameMaxLength": "Il nome legale è troppo lungo.",
  "organigram.panel.validation.nameMaxLength": "Il nome è troppo lungo.",
  "organigram.panel.validation.nameRequired": "Il nome è obbligatorio.",
  "organigram.panel.validation.vacationWaitingPeriodRange": "Inserire un numero intero da 0 a 120, oppure lasciare vuoto per ereditare.",
  "organigram.position.empty": "Nessuna assegnazione",
  "organigram.position.label": "Posizione",
  "organigram.position.more": "Altre azioni",
  "organigram.position.personOne": "persona",
  "organigram.position.personOther": "persone",
  "organigram.position.roleOne": "ruolo",
  "organigram.position.roleOther": "ruoli",
  "organigram.row.openPerson": "Apri persona",
  "organigram.row.primary": "Posizione principale",
  "organigram.row.removeAssignment": "Rimuovi assegnazione",
  "organigram.row.secondary": "Assegnazione",
  "organigram.title": "Organigramma",
  "organigram.toolbar.all": "Tutto",
  "organigram.toolbar.arrange": "Disponi",
  "organigram.toolbar.arrangeHint": "Riordina l'organigramma come al caricamento",
  "organigram.toolbar.collapseAll": "Comprimi tutto",
  "organigram.toolbar.collapsePositions": "Nascondi le posizioni di tutte le unità",
  "organigram.toolbar.expandAll": "Espandi posizioni, persone e stazioni",
  "organigram.toolbar.expandPositions": "Mostra le posizioni di tutte le unità",
  "organigram.toolbar.positions": "Posizioni",
  "organigram.zoom.fit": "Adatta organigramma alla vista",
  "organigram.zoom.in": "Ingrandisci",
  "organigram.zoom.out": "Riduci",
  "organigram.zoom.reset": "Reimposta zoom al 100%",
  "organization.entity.group.people": "People",
  "organization.entity.group.structure": "Structure",
  "organization.entity.organigram": "Organigramma",
  "organization.entity.organizationUnit": "Organization Unit",
  "organization.entity.person": "Person",
  "organization.entity.personPosition": "Person Position",
  "organization.entity.position": "Position",
  "organization.persons.actions.addAndInvite": "Aggiungi persona e invita",
  "organization.persons.actions.creating": "Creazione…",
  "organization.persons.actions.resendInvite": "Reinvia invito",
  "organization.persons.confirmRemove": "Rimuovere {{name}} da questa organizzazione?",
  "organization.persons.empty": "Nessuna persona in questa organizzazione.",
  "organization.persons.errors.createFailed": "Impossibile creare la persona.",
  "organization.persons.errors.removeFailed": "Impossibile rimuovere la persona.",
  "organization.persons.errors.resendFailed": "Impossibile reinviare l'invito.",
  "organization.persons.fields.email": "E-mail",
  "organization.persons.fields.firstName": "Nome",
  "organization.persons.fields.isOwner": "Come amministratore / proprietario dell'organizzazione",
  "organization.persons.fields.lastName": "Cognome",
  "organization.persons.inviteLink": "Link",
  "organization.persons.inviteSent": "Invito inviato a {{email}}.",
  "organization.persons.loading": "Caricamento persone…",
  "organization.persons.status.invited": " · invitato",
  "organization.persons.status.linked": " · collegato",
  "organization.persons.title": "Persone",
  "payScale.grades.actions.create": "Crea gruppo salariale",
  "payScale.grades.actions.edit": "Modifica",
  "payScale.grades.actions.saving": "Salvataggio…",
  "payScale.grades.columns.code": "Codice",
  "payScale.grades.columns.employmentRelationship": "Categoria di dipendente",
  "payScale.grades.columns.name": "Nome",
  "payScale.grades.columns.payScale": "Contratto collettivo",
  "payScale.grades.columns.validFrom": "Valido dal",
  "payScale.grades.description": "Gestisci i gruppi salariali dei tuoi contratti collettivi.",
  "payScale.grades.details.code": "Codice",
  "payScale.grades.details.employmentRelationship": "Categoria di dipendente",
  "payScale.grades.details.loading": "Caricamento gruppo salariale…",
  "payScale.grades.details.name": "Nome",
  "payScale.grades.details.payScale": "Contratto collettivo",
  "payScale.grades.details.sections.info": "Informazioni sul gruppo salariale",
  "payScale.grades.details.validFrom": "Valido dal",
  "payScale.grades.details.validTo": "Valido fino al",
  "payScale.grades.form.createTitle": "Crea gruppo salariale",
  "payScale.grades.form.editTitle": "Modifica gruppo salariale",
  "payScale.grades.form.fields.code": "Codice",
  "payScale.grades.form.fields.employmentRelationship": "Categoria di dipendente",
  "payScale.grades.form.fields.name": "Nome",
  "payScale.grades.form.fields.payScale": "Contratto collettivo",
  "payScale.grades.form.fields.validFrom": "Valido dal",
  "payScale.grades.form.fields.validTo": "Valido fino al",
  "payScale.grades.form.loading": "Caricamento gruppo salariale…",
  "payScale.grades.form.validation.codeMaxLength": "Il codice è troppo lungo",
  "payScale.grades.form.validation.codeRequired": "Il codice è obbligatorio",
  "payScale.grades.form.validation.employmentRelationshipRequired": "La categoria di dipendente è obbligatoria",
  "payScale.grades.form.validation.nameMaxLength": "Il nome è troppo lungo",
  "payScale.grades.form.validation.nameRequired": "Il nome è obbligatorio",
  "payScale.grades.form.validation.payScaleRequired": "Il contratto collettivo è obbligatorio",
  "payScale.grades.form.validation.validFromRequired": "La data di inizio validità è obbligatoria",
  "payScale.grades.list.placeholderDescription": "Seleziona un gruppo salariale dalla tabella per visualizzarne i dettagli.",
  "payScale.grades.list.placeholderTitle": "Gruppi salariali",
  "payScale.grades.title": "Gruppi salariali",
  "payScale.levels.actions.create": "Crea livello",
  "payScale.levels.actions.edit": "Modifica",
  "payScale.levels.actions.saving": "Salvataggio…",
  "payScale.levels.advanceInfoMonths": "avanzamento dopo {{months}} m.",
  "payScale.levels.advanceInfoYears": "avanzamento dopo {{years}} a.",
  "payScale.levels.columns.amount": "Importo",
  "payScale.levels.columns.levelName": "Livello",
  "payScale.levels.columns.payGrade": "Gruppo salariale",
  "payScale.levels.columns.validFrom": "Valido dal",
  "payScale.levels.description": "Gestisci i livelli salariali di ogni gruppo salariale.",
  "payScale.levels.details.advance": "Avanzamento",
  "payScale.levels.details.amount": "Importo",
  "payScale.levels.details.levelName": "Livello",
  "payScale.levels.details.loading": "Caricamento livello…",
  "payScale.levels.details.nextGrade": "Gruppo successivo",
  "payScale.levels.details.nextLevel": "Livello successivo",
  "payScale.levels.details.payGrade": "Gruppo salariale",
  "payScale.levels.details.sections.info": "Informazioni sul livello",
  "payScale.levels.details.validFrom": "Valido dal",
  "payScale.levels.details.validTo": "Valido fino al",
  "payScale.levels.form.createTitle": "Crea livello",
  "payScale.levels.form.editTitle": "Modifica livello",
  "payScale.levels.form.fields.advanceAfterMonths": "Avanzamento dopo mesi",
  "payScale.levels.form.fields.advanceAfterYears": "Avanzamento dopo anni",
  "payScale.levels.form.fields.amount": "Importo",
  "payScale.levels.form.fields.levelName": "Livello",
  "payScale.levels.form.fields.nextGrade": "Gruppo successivo",
  "payScale.levels.form.fields.nextLevel": "Livello successivo",
  "payScale.levels.form.fields.none": "—",
  "payScale.levels.form.fields.payGrade": "Gruppo salariale",
  "payScale.levels.form.fields.payScale": "Contratto collettivo",
  "payScale.levels.form.fields.validFrom": "Valido dal",
  "payScale.levels.form.fields.validTo": "Valido fino al",
  "payScale.levels.form.loading": "Caricamento livello…",
  "payScale.levels.form.validation.amountRequired": "L'importo è obbligatorio",
  "payScale.levels.form.validation.levelNameRequired": "Il livello è obbligatorio",
  "payScale.levels.form.validation.payGradeRequired": "Il gruppo salariale è obbligatorio",
  "payScale.levels.form.validation.validFromRequired": "La data di inizio validità è obbligatoria",
  "payScale.levels.list.placeholderDescription": "Seleziona un livello dalla tabella per visualizzarne i dettagli.",
  "payScale.levels.list.placeholderTitle": "Livelli salariali",
  "payScale.levels.title": "Livelli salariali",
  "permission.action.create": "Create",
  "permission.action.delete": "Delete",
  "permission.action.read": "Read",
  "permission.action.sendInvite": "Can send invite",
  "permission.action.update": "Update",
  "permission.matrix.action": "Azione",
  "permission.matrix.entity": "Entity / Action",
  "permission.scope.all": "All",
  "permission.scope.child_oe": "Child OE",
  "permission.scope.own": "Own",
  "permission.scope.same_oe": "Same OE",
  "permission.scope.same_position": "Same Position",
  "persons.form.placeholders.city": "Enter city",
  "persons.form.placeholders.country": "Enter country",
  "persons.form.placeholders.personnelNumber": "Enter personnel number",
  "persons.form.placeholders.postalCode": "Enter postal code",
  "persons.form.placeholders.privateMobile": "Enter private mobile number",
  "persons.form.placeholders.socialSecurityNumber": "Enter social security number",
  "persons.form.placeholders.street": "Enter street",
  "persons.form.placeholders.vacationDays": "Enter vacation days",
  "persons.form.validation.cityMaxLength": "City must be 100 characters or less",
  "persons.form.validation.countryMaxLength": "Country must be 100 characters or less",
  "persons.form.validation.personnelNumberMaxLength": "Personnel number must be 50 characters or less",
  "persons.form.validation.postalCodeMaxLength": "Postal code must be 20 characters or less",
  "persons.form.validation.socialSecurityNumberMaxLength": "Social security number must be 50 characters or less",
  "persons.form.validation.streetMaxLength": "Street must be 255 characters or less",
  "persons.list.actions.create": "Create person",
  "persons.list.actions.edit": "Edit",
  "persons.list.actions.deletePerson": "Elimina persona",
  "persons.list.actions.saving": "Saving…",
  "persons.list.actions.sendInvite": "Send invite",
  "persons.list.columns.email": "Email",
  "persons.list.columns.name": "Name",
  "persons.list.columns.type": "Type",
  "persons.list.description": "Browse and manage persons in the selected organization.",
  "persons.list.details.loading": "Loading person…",
  "persons.list.details.sections.account": "Account",
  "persons.list.details.sections.address": "Address",
  "persons.list.details.sections.administration": "Administration",
  "persons.list.details.sections.email": "Email",
  "persons.list.details.sections.meta": "Metadata",
  "persons.list.details.sections.socialSecurityReports": "Social security notifications",
  "persons.list.details.sections.socialSecurityReportsEmpty": "No social security notifications available.",
  "persons.list.fields.accountStatus": "Account status",
  "persons.list.fields.city": "City",
  "persons.list.fields.country": "Country",
  "persons.list.fields.mobile": "Mobile",
  "persons.list.fields.personnelNumber": "Personnel number",
  "persons.list.fields.postalCode": "Postal code",
  "persons.list.fields.privateEmail": "Email (private)",
  "persons.list.fields.privateMobile": "Private mobile",
  "persons.list.fields.socialSecurityNumber": "Social security number",
  "persons.list.fields.street": "Street",
  "persons.list.fields.vacationDays": "Vacation days",
  "persons.list.form.createTitle": "Create person",
  "persons.list.form.editTitle": "Edit person",
  "persons.list.form.loading": "Loading person…",
  "persons.list.form.placeholders.city": "Inserisci la città",
  "persons.list.form.placeholders.country": "Inserisci il paese",
  "persons.list.form.placeholders.employmentRelationship": "Inserisci la categoria di dipendente",
  "persons.list.form.placeholders.employmentScopePercent": "ad es. 100",
  "persons.list.form.placeholders.personnelNumber": "Inserisci il numero di matricola",
  "persons.list.form.placeholders.postalCode": "Inserisci il CAP",
  "persons.list.form.placeholders.privateMobile": "Inserisci il cellulare privato",
  "persons.list.form.placeholders.socialSecurityNumber": "Inserisci il codice previdenziale",
  "persons.list.form.placeholders.street": "Inserisci la via",
  "persons.list.form.placeholders.vacationDays": "Inserisci i giorni di ferie",
  "persons.list.invite.sent": "Invitation sent to {{email}}.",
  "persons.list.noOrganization.description": "Select an organization in the context switcher to view persons.",
  "persons.list.noOrganization.title": "No organization selected",
  "persons.list.placeholderDescription": "Select a person from the table to view details in the drawer.",
  "persons.list.placeholderTitle": "Persons",
  "persons.list.status.invited": "Invited (pending)",
  "persons.list.status.linked": "Linked to user account",
  "persons.list.tabs.details": "Details",
  "persons.list.tabs.settings": "Settings",
  "persons.list.tabs.skills": "Competenze",
  "persons.list.unlink.action": "Unlink account",
  "persons.list.unlink.confirmDescription": "This person will no longer be linked to the user account. The user account itself will not be deleted.",
  "persons.list.unlink.confirmTitle": "Unlink user account?",
  "persons.list.unlink.loading": "Unlinking…",
  "persons.list.unlink.success": "Person unlinked from user account.",
  "persons.profile.assignments.empty.description": "You are linked to this organization but not assigned to a position yet. An administrator needs to place you in the organigram to grant access.",
  "persons.profile.assignments.empty.title": "Not yet placed in the organigram",
  "persons.profile.assignments.noRoles": "No roles",
  "persons.profile.assignments.primary": "Primary",
  "persons.profile.assignments.rolesLabel": "Roles",
  "persons.profile.fields.account": "Account",
  "persons.profile.fields.company": "Company",
  "persons.profile.fields.createdAt": "Created at",
  "persons.profile.fields.email": "Email",
  "persons.profile.fields.personId": "Person ID",
  "persons.profile.fields.phone": "Phone",
  "persons.profile.fields.type": "Type",
  "persons.profile.loading": "Loading profile…",
  "persons.profile.noOrganization.description": "Select an organization in the context switcher to view your profile.",
  "persons.profile.noOrganization.title": "No organization selected",
  "persons.profile.noPerson.description": "No person is linked to your user account in this organization.",
  "persons.profile.noPerson.title": "No person in this organization",
  "persons.profile.sections.assignments": "Positions & roles",
  "persons.profile.sections.contact": "Contact",
  "persons.profile.sections.meta": "Metadata",
  "persons.profile.title": "Profile",
  "processing.closing.alreadyClosed": "Questo periodo è già chiuso.",
  "processing.closing.blockedByContracts": "Chiusura non possibile: {{count}} contratti su {{seen}} hanno un errore. Il resto è salvato.",
  "processing.closing.close": "Chiudi {{period}}",
  "processing.closing.hint": "Una chiusura blocca il periodo e registra i saldi. La riapertura non cancella nulla: la chiusura resta visibile come annullata.",
  "processing.closing.needsCompletedRun": "Una chiusura richiede un’elaborazione conclusa con successo.",
  "processing.closing.reopen": "Riapri",
  "processing.closing.snapshots": "{{count}} saldi registrati",
  "processing.closing.title": "Chiusura",
  "processing.log.covers": "{{days}} giorni · {{contracts}} rapporti di lavoro",
  "processing.log.days.title": "Giorni e rapporti di lavoro",
  "processing.log.days.none": "Questa elaborazione non era responsabile di alcun giorno.",
  "processing.log.days.date": "Data",
  "processing.log.days.employment": "Rapporto di lavoro",
  "processing.log.days.status": "Stato",
  "processing.log.days.statuses.SUCCEEDED": "Riuscito",
  "processing.log.days.statuses.FAILED": "Errore",
  "processing.log.days.statuses.SKIPPED": "Saltato",
  "processing.log.days.reason": "Spiegazione",
  "processing.log.days.segments": "Segmenti",
  "processing.log.days.entries": "Registrazioni",
  "processing.log.days.warnings": "Avvisi",
  "processing.log.newRun": "Nuova elaborazione",
  "processing.log.run": "Elaborazione",
  "processing.log.subtitle": "Stato dell'elaborazione fino alla persona e al giorno, invece di un unico errore complessivo.",
  "processing.log.totals.succeeded": "Giorni riusciti",
  "processing.log.totals.failed": "Giorni con errore",
  "processing.log.totals.skipped": "Giorni saltati",
  "processing.log.totals.dependent": "Giorni successivi dipendenti",
  "processing.messages.ABSENCE_ALREADY_BOOKED": "Assenza già registrata",
  "processing.messages.ABSENCE_ENTERED_BY_HAND": "Assenza inserita a mano",
  "processing.messages.ABSENCE_NO_TIME_TYPE": "Assenza senza tipo di tempo",
  "processing.messages.ABSENCE_SPAN_WITHDRAWN": "Periodo di assenza ritirato",
  "processing.messages.ABSENCE_UNKNOWN_TIME_TYPE": "Assenza con tipo di tempo sconosciuto",
  "processing.messages.ABSENCE_VALUED": "Assenza valutata",
  "processing.messages.ABSENCE_WITHOUT_SEGMENT": "Assenza senza segmento",
  "processing.messages.ACCOUNT_ALREADY_AT_VALUE": "Il conto è già a questo valore",
  "processing.messages.AMBIGUOUS_SEGMENT_START": "Inizio del segmento ambiguo",
  "processing.messages.BOOKING_NO_ACCOUNT": "Registrazione senza conto",
  "processing.messages.BOOKING_NO_AMOUNT": "Registrazione senza importo",
  "processing.messages.BOOKING_NO_VALUATION": "Registrazione senza valutazione",
  "processing.messages.BREAK_RULE_NO_THRESHOLD": "Regola di pausa senza soglia",
  "processing.messages.BREAK_SHORTFALL_DEDUCTED": "Pausa mancante detratta",
  "processing.messages.BREAK_SHORTFALL_UNCOVERED": "Pausa mancante non coperta",
  "processing.messages.CATCH_UP_DAYS_ADDED": "Giorni precedenti recuperati",
  "processing.messages.CATCH_UP_LIMIT_REACHED": "Limite di recupero raggiunto; i giorni restanti restano aperti",
  "processing.messages.CLOSURE_DAY_LOCKED": "Giorno bloccato da una chiusura",
  "processing.messages.CONDITION_NOT_EVALUABLE": "Condizione non valutabile",
  "processing.messages.CLOSURE_AFTER_FAILED_DAY": "Fase di chiusura non eseguita — il periodo presenta una lacuna",
  "processing.messages.CORRECTION_NOT_IMPLEMENTED": "Correzione non implementata",
  "processing.messages.CORRECTION_NO_SEGMENT": "La correzione non ha trovato segmenti",
  "processing.messages.CORRECTION_NO_TIME": "Correzione senza orario valido",
  "processing.messages.DAILY_DURATION_LIMIT_REACHED": "Durata massima giornaliera raggiunta",
  "processing.messages.DAILY_LIMIT_NOT_READABLE": "Durata massima giornaliera non leggibile",
  "processing.messages.DAY_FAILED": "Giorno fallito",
  "processing.messages.DAY_LOCKED": "Giorno bloccato",
  "processing.messages.DAY_PLAN_MISSING": "Nessun programma giornaliero",
  "processing.messages.DEPENDENT_DAY_SKIPPED": "Saltato — un giorno precedente di questo rapporto di lavoro è fallito",
  "processing.messages.DEPENDENT_DAYS_ADDED": "Giorni successivi dipendenti ricalcolati",
  "processing.messages.EARLIER_ENTRIES_REVERSED": "Registrazioni di un’elaborazione precedente stornate",
  "processing.messages.EARLIEST_START_APPLIED": "Inizio più presto applicato",
  "processing.messages.EMPLOYMENT_FAILED": "Rapporto di lavoro non elaborato",
  "processing.messages.NO_SEGMENTATION_RULES": "Nessuna regola di segmentazione",
  "processing.messages.OPEN_SEGMENT_AFTER_CORRECTIONS": "Segmento aperto dopo le correzioni",
  "processing.messages.OVERLAPPING_SEGMENT_START": "Inizio del segmento sovrapposto",
  "processing.messages.RULE_MESSAGE": "Messaggio dal regolamento",
  "processing.messages.RULE_SET_INHERITED": "Regolamento ereditato da un’unità superiore",
  "processing.messages.RULE_SET_NOT_COMPILED": "Regolamento non compilato",
  "processing.messages.SECTION_RULE_NO_ACCOUNT": "Regola di sezione senza conto",
  "processing.messages.SECTION_RULE_WRONG_PHASE": "Regola di sezione nella fase sbagliata",
  "processing.messages.SEGMENT_CREATED": "Segmento creato dal regolamento",
  "processing.messages.SEGMENT_NOT_CLOSED": "Segmento non chiuso",
  "processing.messages.SEGMENT_NOT_FORWARD": "Il segmento non procede in avanti",
  "processing.messages.SEGMENT_NO_END": "Segmento senza fine",
  "processing.messages.SEGMENT_NO_START": "Segmento senza inizio",
  "processing.messages.SEGMENT_NO_TIME_TYPE": "Segmento senza tipo di tempo",
  "processing.messages.SEGMENT_UNKNOWN_TIME_TYPE": "Segmento con tipo di tempo sconosciuto",
  "processing.messages.STATEMENT_NOT_IMPLEMENTED": "Istruzione non ancora implementata",
  "processing.messages.TIMEZONE_FALLBACK": "Fuso orario di riserva utilizzato",
  "processing.messages.TRANSFER_INCOMPLETE": "Giroconto incompleto",
  "processing.messages.UNKNOWN_ACCOUNT": "Conto sconosciuto",
  "processing.messages.UNKNOWN_TIME_TYPE": "Tipo di tempo sconosciuto",
  "processing.messages.UNUSED_BOOKING": "Registrazione non utilizzata",
  "processing.messages.VARIABLE_NOT_RESOLVED": "Variabile non risolta",
  "processing.overview.covers": "Su questa unità e tutto ciò che vi sta sotto — {{count}} unità. Un'elaborazione copre solo quella scelta.",
  "processing.overview.errors.loadFailed": "Non è stato possibile caricare gli indicatori.",
  "processing.overview.lastProcessed": "Ultima elaborazione",
  "processing.overview.lastProcessedHint": "l'ultima elaborazione conclusa",
  "processing.overview.never": "mai",
  "processing.overview.openDays": "Giorni aperti",
  "processing.overview.openDaysHint": "fino a ieri, non raggiunti da nessuna elaborazione riuscita",
  "processing.overview.retroactive": "Correzioni retroattive",
  "processing.overview.retroactiveHint": "giorni già calcolati la cui timbratura è arrivata dopo",
  "processing.overview.withErrors": "Rapporti di lavoro con errore",
  "processing.overview.withErrorsHint": "nella rispettiva elaborazione più recente",
  "processing.result.bookings": "Registrazioni",
  "processing.result.dayTotal": "Totale giornaliero",
  "processing.result.employment": "Rapporto",
  "processing.result.empty": "Questa elaborazione non ha prodotto segmenti, registrazioni o messaggi.",
  "processing.result.errorCount": "{{count}} errori",
  "processing.result.errors.loadFailed": "Impossibile caricare il risultato.",
  "processing.result.contract.statuses.SUCCEEDED": "riuscito",
  "processing.result.contract.statuses.PARTIAL": "parzialmente riuscito",
  "processing.result.contract.statuses.FAILED": "non riuscito",
  "processing.result.contract.statuses.SKIPPED": "saltato",
  "processing.result.contract.figures": "{{from}} – {{to}}: {{succeeded}} giorni calcolati, {{failed}} con errori, {{skipped}} saltati, {{entries}} registrazioni",
  "processing.result.governance.inheritedFrom": "· ereditato da {{unit}}",
  "processing.result.governance.skipped.NO_RULE_SET": "Nessun regolamento per questo modello orario — nulla calcolato",
  "processing.result.governance.skipped.NO_WORK_SCHEDULE": "Nessun modello orario impostato — nulla calcolato",
  "processing.result.governance.skippedCount": "{{count}} contratti senza regolamento",
  "processing.result.governance.title": "Regolamenti applicati",
  "processing.result.governance.version": "Versione {{version}}",
  "processing.result.governance.workSchedule": "Modello orario",
  "processing.result.messageGroups.perContract": "Singoli contratti",
  "processing.result.messageGroups.runLevel": "Riguarda tutta l’elaborazione",
  "processing.result.messages": "Messaggi",
  "processing.result.noBookings": "Questa elaborazione non ha registrato nulla.",
  "processing.result.open": "aperto",
  "processing.result.phase": "Fase {{phase}}",
  "processing.result.segments": "Segmenti",
  "processing.result.summary.contracts": "{{clean}} contratti su {{seen}} sono andati a buon fine.",
  "processing.result.summary.runLevel": "Errori che riguardano tutta l’elaborazione: {{count}}",
  "processing.result.summary.withErrors": "Di cui {{count}} con errore.",
  "processing.result.superseded": "sostituito",
  "processing.result.warningCount": "{{count}} avvisi",
  "processing.run.configure": "Configurare l'elaborazione",
  "processing.run.contracts": "{{count}} rapporti di lavoro",
  "processing.run.covers": "Comprende {{count}} rapporti di lavoro.",
  "processing.run.coversOne": "Comprende un rapporto di lavoro.",
  "processing.run.employment": "Rapporto di lavoro",
  "processing.run.errors.listFailed": "Impossibile caricare le elaborazioni.",
  "processing.run.errors.noEmployment": "Questa unità non offre alcun rapporto di lavoro da scegliere.",
  "processing.run.errors.noEmployments": "Questa unità non ha rapporti di lavoro — l’elaborazione non calcolerebbe nulla.",
  "processing.run.errors.periodOrder": "La fine non può precedere l’inizio.",
  "processing.run.errors.startFailed": "Impossibile avviare l’elaborazione.",
  "processing.run.flow.title": "Svolgimento dell'elaborazione",
  "processing.run.flow.SEGMENTATION.title": "Segmentazione",
  "processing.run.flow.SEGMENTATION.detail": "Timbrature e assenze diventano segmenti di tempo.",
  "processing.run.flow.CORRECTIONS.title": "Correzioni",
  "processing.run.flow.CORRECTIONS.detail": "Le regole correggono i segmenti; la versione sostituita resta leggibile.",
  "processing.run.flow.CALCULATION.title": "Calcolo",
  "processing.run.flow.CALCULATION.detail": "Pause, ore previste ed effettive, giorno per giorno.",
  "processing.run.flow.BOOKINGS.title": "Registrazioni",
  "processing.run.flow.BOOKINGS.detail": "Movimenti di conto. Le registrazioni di elaborazioni precedenti per gli stessi giorni vengono stornate.",
  "processing.run.flow.CLOSURES.title": "Chiusure",
  "processing.run.flow.CLOSURES.detail": "Viene eseguita a ogni elaborazione; il regolamento decide con «on run» che cosa accade.",
  "processing.run.flow.synchronous": "L'elaborazione dipende da questa chiamata, non da un servizio in background: la pagina attende la fine e apre poi il protocollo.",
  "processing.run.from": "Da",
  "processing.run.hints.recomputes": "Tutti i giorni da–a vengono ricalcolati, indipendentemente dalle elaborazioni precedenti. Le loro registrazioni per questi giorni vengono stornate.",
  "processing.run.hints.runType": "Il tipo decide solo quali regole «on run» del regolamento vengono attivate. Ogni giorno del periodo viene comunque calcolato.",
  "processing.run.isolation": "Isolamento degli errori: un giorno in errore non blocca né gli altri rapporti di lavoro né i giorni precedenti. I giorni successivi dello stesso rapporto vengono saltati, perché si basano su di esso.",
  "processing.run.none": "Questa unità non ha ancora elaborazioni.",
  "processing.run.noUnits": "Nessuna unità organizzativa disponibile.",
  "processing.run.open": "Apri",
  "processing.run.openLog": "Apri protocollo",
  "processing.run.lastRun.contracts": "{{seen}} rapporti di lavoro, {{clean}} senza errori, {{errors}} con errori",
  "processing.run.lastRun.title": "{{name}}:",
  "processing.run.outcome.SUCCEEDED": "Riuscita",
  "processing.run.outcome.PARTIAL": "Parziale",
  "processing.run.outcome.FAILED": "Errore",
  "processing.run.outcome.RUNNING": "In corso",
  "processing.run.preview.catchUp": ", più {{count}} giorni che l’elaborazione recupera da sé",
  "processing.run.preview.catchUpDays": "+{{count}} prima del periodo",
  "processing.run.preview.check": "Controlla l'anteprima",
  "processing.run.preview.days": "{{count}} giorni",
  "processing.run.preview.dependentDays": "+{{count}} dopo (dipendenti)",
  "processing.run.preview.empty": "Questa unità non ha alcun rapporto di lavoro.",
  "processing.run.preview.errors.failed": "Non è stato possibile caricare l'anteprima.",
  "processing.run.preview.inherited": "· ereditato da {{unit}}",
  "processing.run.preview.locked": ", di cui {{count}} bloccati da una chiusura",
  "processing.run.preview.noDays": "nessun giorno nel periodo",
  "processing.run.preview.outsideWindow": "il periodo è fuori dal rapporto di lavoro",
  "processing.run.preview.period": " Periodo: {{days}} giorni",
  "processing.run.preview.scheduleChanges": "il modello orario cambia nel periodo — il regolamento mostrato è quello del primo giorno",
  "processing.run.preview.summary": "{{compute}} di {{total}} rapporti verrebbero calcolati, {{skip}} saltati.",
  "processing.run.preview.title": "Che cosa toccherebbe questa elaborazione",
  "processing.run.preview.version": "versione {{version}}",
  "processing.run.recent": "Elaborazioni recenti",
  "processing.run.scope": "Ambito",
  "processing.run.scopes.UNIT": "Intera unità organizzativa",
  "processing.run.scopes.EMPLOYMENT": "Un singolo rapporto di lavoro",
  "processing.run.selectHint": "Scegli un'elaborazione qui sopra per vederne il risultato.",
  "processing.run.start": "Avvia elaborazione",
  "processing.run.subtitle": "Ricalcolare un periodo e aprire un'elaborazione precedente.",
  "processing.run.table.startedAt": "Avviata",
  "processing.run.table.period": "Periodo",
  "processing.run.table.runType": "Tipo",
  "processing.run.table.scope": "Ambito",
  "processing.run.table.outcome": "Esito",
  "processing.run.table.number": "N. elaborazione",
  "processing.run.to": "A",
  "processing.run.type": "Tipo di elaborazione",
  "processing.run.types.DAILY": "Giornaliera",
  "processing.run.types.PERIOD": "Periodo",
  "processing.run.types.RECALCULATION": "Ricalcolo",
  "processing.run.types.CLOSING": "Chiusura",
  "processing.run.unit": "Unità organizzativa",
  "settings.accounts.actions.create": "Create user",
  "settings.accounts.actions.edit": "Edit",
  "settings.accounts.actions.saving": "Saving…",
  "settings.accounts.columns.email": "Email",
  "settings.accounts.columns.name": "Name",
  "settings.accounts.description": "Manage user accounts and role assignments.",
  "settings.accounts.details.assignedRoles": "Assigned roles",
  "settings.accounts.details.fullName": "Full name",
  "settings.accounts.details.loading": "Loading user…",
  "settings.accounts.details.noRolesAssigned": "No roles assigned",
  "settings.accounts.details.sections.access": "Access",
  "settings.accounts.details.sections.userInfo": "User information",
  "settings.accounts.details.status": "Status",
  "settings.accounts.details.statusApproved": "Approved",
  "settings.accounts.details.statusPending": "Pending approval",
  "settings.accounts.details.userId": "User ID",
  "settings.accounts.form.createTitle": "Create user",
  "settings.accounts.form.editTitle": "Edit user",
  "settings.accounts.form.fields.email": "Email",
  "settings.accounts.form.fields.isApproved": "Approved for access",
  "settings.accounts.form.fields.isApprovedHint": "Allow this account to sign in to Workforce.",
  "settings.accounts.form.fields.name": "Full name",
  "settings.accounts.form.fields.role": "Ruolo",
  "settings.accounts.form.fields.roleHint": "Seleziona il ruolo per questo utente.",
  "settings.accounts.form.fields.roleValue.admin": "Admin",
  "settings.accounts.form.fields.roleValue.superAdmin": "Super Admin",
  "settings.accounts.form.fields.roleValue.user": "Utente",
  "settings.accounts.form.loading": "Loading user…",
  "settings.accounts.form.roles.noRolesAvailable": "No roles available",
  "settings.accounts.form.roles.selected": "selected",
  "settings.accounts.form.roles.title": "Roles",
  "settings.accounts.form.validation.nameMaxLength": "Name is too long",
  "settings.accounts.form.validation.nameRequired": "Name is required",
  "settings.accounts.list.placeholderDescription": "Select a user from the table to view details in the drawer.",
  "settings.accounts.list.placeholderTitle": "User accounts",
  "settings.accounts.title": "Users",
  "settings.organizations.actions.create": "Create organization",
  "settings.organizations.actions.edit": "Edit",
  "settings.organizations.actions.saving": "Saving…",
  "settings.organizations.columns.createdAt": "Created at",
  "settings.organizations.columns.name": "Name",
  "settings.organizations.description": "Manage organizations (power user feature).",
  "settings.organizations.details.createdAt": "Created at",
  "settings.organizations.details.loading": "Loading organization…",
  "settings.organizations.details.name": "Name",
  "settings.organizations.details.organizationId": "Organization ID",
  "settings.organizations.details.sections.info": "Organization information",
  "settings.organizations.form.createTitle": "Create organization",
  "settings.organizations.form.editTitle": "Edit organization",
  "settings.organizations.form.fields.name": "Name",
  "settings.organizations.form.fields.owners": "Owners / Admins",
  "settings.organizations.form.fields.ownersEmpty": "No persons found.",
  "settings.organizations.form.fields.ownersHint": "Selected persons are added as admins of this organization (Owner position on the root unit).",
  "settings.organizations.form.fields.ownersSearch": "Search persons…",
  "settings.organizations.form.loading": "Loading organization…",
  "settings.organizations.form.validation.nameMaxLength": "Name is too long",
  "settings.organizations.form.validation.nameRequired": "Name is required",
  "settings.organizations.list.placeholderDescription": "Select an organization from the table to view details in the drawer.",
  "settings.organizations.list.placeholderTitle": "Organizations",
  "settings.organizations.title": "Organizations",
  "settings.payScales.actions.create": "Crea contratto collettivo",
  "settings.payScales.actions.edit": "Modifica",
  "settings.payScales.actions.saving": "Salvataggio…",
  "settings.payScales.columns.code": "Codice",
  "settings.payScales.columns.name": "Nome",
  "settings.payScales.columns.validFrom": "Valido dal",
  "settings.payScales.columns.validTo": "Valido fino al",
  "settings.payScales.columns.weeklyWorkHours": "Ore settimanali",
  "settings.payScales.description": "Gestisci i contratti collettivi con i loro gruppi e livelli salariali.",
  "settings.payScales.details.code": "Codice",
  "settings.payScales.details.createdAt": "Creato il",
  "settings.payScales.details.dailyWorkHours": "Orario di lavoro giornaliero",
  "settings.payScales.details.loading": "Caricamento contratto collettivo…",
  "settings.payScales.details.monthlyWorkHours": "Orario di lavoro mensile",
  "settings.payScales.details.name": "Nome",
  "settings.payScales.details.sections.apprenticeIncome": "Retribuzione apprendisti",
  "settings.payScales.details.sections.info": "Informazioni sul contratto collettivo",
  "settings.payScales.details.sections.salaryTables": "Tabelle retribuzione minima",
  "settings.payScales.details.table.amount": "Importo",
  "settings.payScales.details.table.emptyCell": "—",
  "settings.payScales.details.table.level": "Livello",
  "settings.payScales.details.tablesEmpty": "Per questo contratto collettivo non sono ancora configurati gruppi o livelli salariali.",
  "settings.payScales.details.tablesLoading": "Caricamento tabelle salariali…",
  "settings.payScales.details.validFrom": "Valido dal",
  "settings.payScales.details.validTo": "Valido fino al",
  "settings.payScales.details.weeklyWorkHours": "Orario di lavoro settimanale",
  "settings.payScales.form.createTitle": "Crea contratto collettivo",
  "settings.payScales.form.editTitle": "Modifica contratto collettivo",
  "settings.payScales.form.fields.code": "Codice",
  "settings.payScales.form.fields.dailyWorkHours": "Orario di lavoro giornaliero",
  "settings.payScales.form.fields.monthlyWorkHours": "Orario di lavoro mensile",
  "settings.payScales.form.fields.name": "Nome",
  "settings.payScales.form.fields.validFrom": "Valido dal",
  "settings.payScales.form.fields.validTo": "Valido fino al",
  "settings.payScales.form.fields.weeklyWorkHours": "Orario di lavoro settimanale",
  "settings.payScales.form.loading": "Caricamento contratto collettivo…",
  "settings.payScales.form.validation.codeMaxLength": "Il codice è troppo lungo",
  "settings.payScales.form.validation.codeRequired": "Il codice è obbligatorio",
  "settings.payScales.form.validation.nameMaxLength": "Il nome è troppo lungo",
  "settings.payScales.form.validation.nameRequired": "Il nome è obbligatorio",
  "settings.payScales.form.validation.validFromRequired": "La data di inizio validità è obbligatoria",
  "settings.payScales.list.placeholderDescription": "Seleziona un contratto collettivo dalla tabella per visualizzarne i dettagli.",
  "settings.payScales.list.placeholderTitle": "Contratti collettivi",
  "settings.payScales.title": "Contratti collettivi",
  "settings.profile.fields.company": "Company",
  "settings.profile.fields.createdAt": "Created at",
  "settings.profile.fields.email": "Email",
  "settings.profile.fields.personId": "Person ID",
  "settings.profile.fields.phone": "Phone",
  "settings.profile.fields.type": "Type",
  "settings.profile.loading": "Loading profile…",
  "settings.profile.noOrganization.description": "Select an organization in the context switcher to view your profile in that organization.",
  "settings.profile.noOrganization.title": "No organization selected",
  "settings.profile.noPerson.description": "No person is linked to your user account in this organization.",
  "settings.profile.noPerson.title": "No person in this organization",
  "settings.profile.sections.contact": "Contact",
  "settings.profile.sections.meta": "Metadata",
  "settings.profile.title": "Profile",
  "settings.roles.actions.cancel": "Annulla",
  "settings.roles.actions.create": "Crea",
  "settings.roles.actions.edit": "Modifica",
  "settings.roles.actions.save": "Salva",
  "settings.roles.actions.saving": "Salvataggio in corso…",
  "settings.roles.columns.description": "Description",
  "settings.roles.columns.name": "Name",
  "settings.roles.description": "Manage organization roles and permissions",
  "settings.roles.form.createTitle": "Crea ruolo",
  "settings.roles.form.editTitle": "Modifica ruolo",
  "settings.roles.form.fields.description": "Descrizione",
  "settings.roles.form.fields.name": "Nome",
  "settings.roles.form.loading": "Caricamento del ruolo in corso…",
  "settings.roles.form.section.info": "Informazioni ruolo",
  "settings.roles.form.validation.descriptionMaxLength": "La descrizione è troppo lunga",
  "settings.roles.form.validation.nameMaxLength": "Il nome è troppo lungo",
  "settings.roles.form.validation.nameRequired": "Il nome è obbligatorio",
  "settings.roles.list.placeholderDescription": "Seleziona un ruolo dalla tabella per visualizzare i dettagli nel cassetto.",
  "settings.roles.list.placeholderTitle": "Ruoli",
  "settings.roles.permissionMatrix": "Permission Matrix",
  "settings.roles.permissionMatrixDescription": "View the permissions granted to this role across different scopes and entities",
  "settings.roles.title": "Roles",
  "settings.textCatalog.actions.backToCatalog": "Torna alle voci di catalogo",
  "settings.textCatalog.actions.create": "Create entry",
  "settings.textCatalog.actions.edit": "Edit",
  "settings.textCatalog.actions.manageLanguages": "Manage languages",
  "settings.textCatalog.actions.manageTypes": "Gestisci tipi di catalogo",
  "settings.textCatalog.actions.saving": "Saving…",
  "settings.textCatalog.columns.catalogKey": "Key",
  "settings.textCatalog.columns.catalogType": "Type",
  "settings.textCatalog.columns.name": "Label",
  "settings.textCatalog.columns.scope": "Ambito",
  "settings.textCatalog.description": "Gestisci voci di catalogo dinamiche e le relative traduzioni.",
  "settings.textCatalog.details.loading": "Loading catalog entry…",
  "settings.textCatalog.details.sections.info": "Entry details",
  "settings.textCatalog.filters.catalogType": "Catalog type",
  "settings.textCatalog.filters.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.form.createTitle": "Create catalog entry",
  "settings.textCatalog.form.editTitle": "Edit catalog entry",
  "settings.textCatalog.form.fields.catalogKey": "Key",
  "settings.textCatalog.form.fields.catalogKeyPlaceholder": "female",
  "settings.textCatalog.form.fields.catalogType": "Type",
  "settings.textCatalog.form.fields.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.form.fields.countryCode": "Paese",
  "settings.textCatalog.form.fields.countryCodePlaceholder": "Seleziona il paese",
  "settings.textCatalog.form.fields.noActiveLanguages": "Nessuna lingua attiva configurata.",
  "settings.textCatalog.form.fields.organization": "Organizzazione",
  "settings.textCatalog.form.fields.organizationPlaceholder": "Seleziona l'organizzazione",
  "settings.textCatalog.form.fields.organizationUnit": "Unità organizzativa",
  "settings.textCatalog.form.fields.organizationUnitPlaceholder": "Seleziona l'unità organizzativa",
  "settings.textCatalog.form.fields.scope": "Ambito",
  "settings.textCatalog.form.fields.scopePlaceholder": "Seleziona l'ambito",
  "settings.textCatalog.form.fields.translationPlaceholder": "Translation for {{language}}",
  "settings.textCatalog.form.fields.translations": "Translations",
  "settings.textCatalog.form.loading": "Loading catalog entry…",
  "settings.textCatalog.form.scope.country": "Paese",
  "settings.textCatalog.form.scope.global": "Globale",
  "settings.textCatalog.form.scope.organizationUnit": "Unità organizzativa",
  "settings.textCatalog.form.section.identity": "Identity",
  "settings.textCatalog.form.section.scope": "Ambito",
  "settings.textCatalog.form.validation.catalogKeyMaxLength": "Key is too long",
  "settings.textCatalog.form.validation.catalogKeyPattern": "Key may only contain letters, numbers, underscores, and dashes",
  "settings.textCatalog.form.validation.catalogKeyRequired": "Key is required",
  "settings.textCatalog.form.validation.catalogTypeMaxLength": "Type is too long",
  "settings.textCatalog.form.validation.catalogTypePattern": "Type must be uppercase letters, numbers, and underscores",
  "settings.textCatalog.form.validation.catalogTypeRequired": "Type is required",
  "settings.textCatalog.form.validation.scopeRequired": "L'ambito è obbligatorio",
  "settings.textCatalog.languages.actions.create": "Create language",
  "settings.textCatalog.languages.actions.edit": "Edit",
  "settings.textCatalog.languages.actions.saving": "Saving…",
  "settings.textCatalog.languages.columns.code": "Code",
  "settings.textCatalog.languages.columns.isActive": "Active",
  "settings.textCatalog.languages.columns.name": "Name",
  "settings.textCatalog.languages.columns.sortOrder": "Sort order",
  "settings.textCatalog.languages.description": "Manage available languages for catalog translations.",
  "settings.textCatalog.languages.details.loading": "Loading language…",
  "settings.textCatalog.languages.details.sections.info": "Language details",
  "settings.textCatalog.languages.form.createTitle": "Create language",
  "settings.textCatalog.languages.form.editTitle": "Edit language",
  "settings.textCatalog.languages.form.fields.code": "Code",
  "settings.textCatalog.languages.form.fields.codePlaceholder": "en",
  "settings.textCatalog.languages.form.fields.isActive": "Active",
  "settings.textCatalog.languages.form.fields.name": "Name",
  "settings.textCatalog.languages.form.fields.namePlaceholder": "English",
  "settings.textCatalog.languages.form.fields.sortOrder": "Sort order",
  "settings.textCatalog.languages.form.loading": "Loading language…",
  "settings.textCatalog.languages.form.section.info": "Language",
  "settings.textCatalog.languages.form.validation.codeMaxLength": "Code is too long",
  "settings.textCatalog.languages.form.validation.codeMinLength": "Code must be at least 2 characters",
  "settings.textCatalog.languages.form.validation.codePattern": "Code may only contain letters, numbers, underscores, and dashes",
  "settings.textCatalog.languages.form.validation.codeRequired": "Code is required",
  "settings.textCatalog.languages.form.validation.nameMaxLength": "Name is too long",
  "settings.textCatalog.languages.form.validation.nameRequired": "Name is required",
  "settings.textCatalog.languages.list.placeholderDescription": "Select a language from the table to view details in the drawer.",
  "settings.textCatalog.languages.list.placeholderTitle": "Languages",
  "settings.textCatalog.languages.title": "Languages",
  "settings.textCatalog.list.placeholderDescription": "Select a catalog entry from the table to view details in the drawer.",
  "settings.textCatalog.list.placeholderTitle": "Catalog entries",
  "settings.textCatalog.title": "Catalogo testi",
  "settings.textCatalog.types.actions.create": "Crea tipo di catalogo",
  "settings.textCatalog.types.actions.edit": "Modifica",
  "settings.textCatalog.types.actions.saving": "Salvataggio…",
  "settings.textCatalog.types.columns.catalogType": "Tipo",
  "settings.textCatalog.types.columns.permissionAction": "Azione permesso",
  "settings.textCatalog.types.columns.permissionEntity": "Entità permesso",
  "settings.textCatalog.types.description": "Registra i tipi di catalogo e definisci quale autorizzazione è necessaria per le letture nel contesto di un'unità organizzativa.",
  "settings.textCatalog.types.details.loading": "Caricamento del tipo di catalogo…",
  "settings.textCatalog.types.details.sections.info": "Dettagli del tipo",
  "settings.textCatalog.types.form.createTitle": "Crea tipo di catalogo",
  "settings.textCatalog.types.form.editTitle": "Modifica tipo di catalogo",
  "settings.textCatalog.types.form.fields.catalogType": "Codice del tipo",
  "settings.textCatalog.types.form.fields.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.types.form.fields.organizations": "Organizzazioni",
  "settings.textCatalog.types.form.fields.organizationsPlaceholder": "Seleziona le organizzazioni",
  "settings.textCatalog.types.form.fields.permissionAction": "Azione autorizzata",
  "settings.textCatalog.types.form.fields.permissionActionPlaceholder": "Seleziona l'azione",
  "settings.textCatalog.types.form.fields.permissionEntity": "Ambito di autorizzazione",
  "settings.textCatalog.types.form.fields.permissionEntityPlaceholder": "Seleziona l'ambito",
  "settings.textCatalog.types.form.fields.permissionNone": "Nessuna",
  "settings.textCatalog.types.form.fields.scopeMode": "Ambito",
  "settings.textCatalog.types.form.fields.scopeModePlaceholder": "Seleziona l'ambito",
  "settings.textCatalog.types.form.loading": "Caricamento del tipo di catalogo…",
  "settings.textCatalog.types.form.permissionHint": "Se impostata, il chiamante deve possedere questa autorizzazione sull'unità organizzativa richiesta per leggere le voci non globali.",
  "settings.textCatalog.types.form.section.identity": "Identificazione",
  "settings.textCatalog.types.form.section.organizations": "Accesso alle organizzazioni",
  "settings.textCatalog.types.form.section.permission": "Autorizzazione nel contesto dell'unità",
  "settings.textCatalog.types.form.validation.catalogTypeMaxLength": "Il tipo è troppo lungo",
  "settings.textCatalog.types.form.validation.catalogTypePattern": "Il tipo può contenere solo lettere maiuscole, numeri e trattini bassi",
  "settings.textCatalog.types.form.validation.catalogTypeRequired": "Il tipo è obbligatorio",
  "settings.textCatalog.types.form.validation.scopeModeRequired": "L'ambito è obbligatorio",
  "settings.textCatalog.types.list.placeholderDescription": "Seleziona un tipo di catalogo nella tabella per vederne i dettagli.",
  "settings.textCatalog.types.list.placeholderTitle": "Tipi di catalogo",
  "settings.textCatalog.types.scopeMode.global": "Globale",
  "settings.textCatalog.types.scopeMode.organization": "Organizzazione",
  "settings.textCatalog.types.title": "Tipi di catalogo",
  "settings.textCatalog.values.no": "No",
  "settings.textCatalog.values.yes": "Yes",
  "skill.entity.group.persons": "Persone",
  "skill.entity.skill": "Competenze",
  "skills.actions.create": "+ Competenza",
  "skills.actions.edit": "Modifica",
  "skills.actions.saving": "Salvataggio …",
  "skills.columns.code": "Sigla",
  "skills.columns.description": "Descrizione",
  "skills.columns.name": "Denominazione",
  "skills.description": "Le competenze di questa organizzazione. Il livello si imposta sulla persona.",
  "skills.details.code": "Sigla",
  "skills.details.description": "Descrizione",
  "skills.details.name": "Denominazione",
  "skills.details.sections.info": "Competenza",
  "skills.form.createTitle": "Nuova competenza",
  "skills.form.editTitle": "Modifica competenza",
  "skills.form.fields.code": "Sigla",
  "skills.form.fields.codeHint": "Breve e univoca. Vi faranno riferimento requisiti e importazioni.",
  "skills.form.fields.codePlaceholder": "ad es. MULETTO",
  "skills.form.fields.description": "Descrizione (facoltativa)",
  "skills.form.fields.name": "Denominazione",
  "skills.form.fields.namePlaceholder": "ad es. Patentino per muletto",
  "skills.form.loading": "Caricamento …",
  "skills.form.validation.codeMaxLength": "La sigla può avere al massimo 50 caratteri.",
  "skills.form.validation.codeRequired": "Indicare una sigla.",
  "skills.form.validation.descriptionMaxLength": "La descrizione può avere al massimo 1000 caratteri.",
  "skills.form.validation.nameMaxLength": "La denominazione può avere al massimo 255 caratteri.",
  "skills.form.validation.nameRequired": "Indicare una denominazione.",
  "skills.level.ASSISTED": "Sotto supervisione",
  "skills.level.EXPERIENCED": "Esperto",
  "skills.level.INDEPENDENT": "Autonomo",
  "skills.level.INSTRUCTOR": "Può formare altri",
  "skills.level.LEARNING": "In formazione",
  "skills.list.placeholderDescription": "Fare clic su una riga per vedere la competenza.",
  "skills.list.placeholderTitle": "Nessuna competenza selezionata",
  "skills.person.add.level": "Livello",
  "skills.person.add.skill": "Competenza",
  "skills.person.add.skillPlaceholder": "Scegli una competenza",
  "skills.person.add.submit": "Aggiungi",
  "skills.person.catalogueError": "Non è stato possibile caricare il catalogo delle competenze.",
  "skills.person.description": "Che cosa sa fare questa persona e a che livello. Le competenze si gestiscono in Persone → Competenze.",
  "skills.person.empty": "Per questa persona non è ancora registrata alcuna competenza.",
  "skills.person.loadError": "Non è stato possibile caricare le competenze di questa persona.",
  "skills.person.loading": "Caricamento …",
  "skills.person.noOrganization": "Questa persona non appartiene a nessuna organizzazione. Le competenze si gestiscono per organizzazione.",
  "skills.person.nothingLeft": "Tutte le competenze del catalogo sono già registrate.",
  "skills.person.remove.confirm": "«{{name}}» verrà rimossa da questa persona. La competenza resta nel catalogo.",
  "skills.person.title": "Competenze",
  "skills.requirements.add.hint": "La scelta la richiede subito con «{{level}}». Il livello si cambia poi nella sua riga.",
  "skills.requirements.add.skill": "Richiedi una competenza",
  "skills.requirements.add.skillPlaceholder": "Scegli una competenza",
  "skills.requirements.atLeast": "almeno",
  "skills.requirements.catalogueError": "Non è stato possibile caricare il catalogo delle competenze.",
  "skills.requirements.empty": "Non è ancora richiesta alcuna competenza.",
  "skills.requirements.loadError": "Non è stato possibile caricare le competenze richieste.",
  "skills.requirements.loading": "Caricamento …",
  "skills.requirements.nothingLeft": "Tutte le competenze del catalogo sono già richieste.",
  "skills.requirements.positionDescription": "Che cosa richiede questa posizione. Il livello è un minimo — chi è più in alto lo soddisfa comunque.",
  "skills.requirements.remove.confirm": "«{{name}}» non sarà più richiesta qui. La competenza resta nel catalogo.",
  "skills.requirements.stationDescription": "Che cosa richiede questa stazione. Il livello è un minimo — chi è più in alto lo soddisfa comunque.",
  "skills.requirements.title": "Competenze richieste",
  "skills.title": "Competenze",
  "table.columns.save": "Salva",
  "table.columns.showAll": "Mostra tutte",
  "table.columns.title": "Colonne",
  "textCatalog.select.empty": "Nessuna voce catalogo disponibile",
  "textCatalog.select.error": "Impossibile caricare le voci catalogo",
  "textCatalog.select.loading": "Caricamento voci catalogo…",
  "timeAccounts.header.noPerson": "Nessun rapporto selezionato",
  "timeAccounts.header.personnelNumber": "Matricola {{number}}",
  "timeAccounts.header.period": "Periodo",
  "timeAccounts.header.previousMonth": "Mese precedente",
  "timeAccounts.header.nextMonth": "Mese successivo",
  "timeAccounts.header.previousYear": "Anno precedente",
  "timeAccounts.header.nextYear": "Anno successivo",
  "timeAccounts.header.workSchedule": "Modello orario",
  "timeAccounts.employment": "Rapporto di lavoro",
  "timeAccounts.errors.loadFailed": "Impossibile caricare i saldi.",
  "timeAccounts.fromEntries": "da {{count}} registrazioni",
  "timeAccounts.grid.date": "Data",
  "timeAccounts.grid.columns": "Colonne",
  "timeAccounts.grid.show": "Mostra",
  "timeAccounts.grid.timeType": "Tipo di tempo",
  "timeAccounts.grid.allTimeTypes": "Tutti i tipi di tempo",
  "timeAccounts.grid.timeTypes": "Tipi di tempo",
  "timeAccounts.grid.filters.all": "Tutti i giorni",
  "timeAccounts.grid.filters.booked": "Solo giorni con registrazioni",
  "timeAccounts.grid.filters.deviating": "Solo scostamenti dal previsto",
  "timeAccounts.grid.dayCount": "{{shown}} di {{total}} giorni",
  "timeAccounts.summary.balanceAfter": "Saldo dopo",
  "timeAccounts.grid.weekday": "Giorno",
  "timeAccounts.grid.spans": "Registrazioni calcolate",
  "timeAccounts.grid.kind": "Tipo di tempo",
  "timeAccounts.grid.break": "Pausa",
  "timeAccounts.grid.deduction": "Detrazione",
  "timeAccounts.grid.note": "Nota",
  "timeAccounts.grid.worked": "Ore effettive",
  "timeAccounts.grid.target": "Ore previste",
  "timeAccounts.grid.overtime": "Straordinari",
  "timeAccounts.grid.toggleDay": "Espandi o riduci il giorno",
  "timeAccounts.grid.loadFailed": "Non è stato possibile caricare il giornale del mese.",
  "timeAccounts.ledgerHint": "Sommato dal giornale delle registrazioni fino alla fine del mese, non da un’istantanea salvata.",
  "timeAccounts.noBalances": "Fino alla fine del mese non è stato registrato nulla per questo rapporto.",
  "timeAccounts.noEmployments": "Questa unità non ha rapporti di lavoro.",
  "timeAccounts.organizationUnit": "Unità organizzativa",
  "timeAccounts.summary.corrections": "Registrazioni particolari e correzioni",
  "timeAccounts.summary.correctionsHint": "Tutto ciò che non è la valutazione del giorno stesso — registrato a mano, da una chiusura o stornato.",
  "timeAccounts.summary.showHiddenAccounts": "Mostra anche i conti nascosti ({{count}})",
  "timeAccounts.summary.noCorrections": "Questo mese non è stato registrato nulla a mano.",
  "timeAccounts.summary.balances": "Saldi dei conti a fine mese",
  "timeAccounts.summary.account": "Conto",
  "timeAccounts.summary.amount": "Importo",
  "timeAccounts.summary.origin": "Origine",
  "timeAccounts.summary.monthChange": "Movimento del mese",
  "timeAccounts.summary.balance": "Saldo",
  "timeAccounts.summary.unit": "Unità",
  "timeAccounts.summary.origins.MANUAL": "A mano",
  "timeAccounts.summary.origins.CLOSING": "Chiusura",
  "timeAccounts.summary.origins.INITIALIZE": "Impostato a un valore",
  "timeAccounts.unit.counter": "",
  "timeAccounts.unit.days": "giorni",
  "timeAccounts.unit.minutes": "h",
  "timeAccounts.unit.number": "",
  "timeManagement.accounts.actions.create": "Crea conto",
  "timeManagement.accounts.delete.confirm": "Vuoi davvero eliminare questo conto?",
  "timeManagement.accounts.displayFormat.DAYS": "Giorni",
  "timeManagement.accounts.displayFormat.DECIMAL_HOURS": "Ore decimali",
  "timeManagement.accounts.displayFormat.HH_MM": "Ore:minuti",
  "timeManagement.accounts.errors.loadFailed": "Impossibile caricare i conti.",
  "timeManagement.accounts.form.createTitle": "Nuovo conto",
  "timeManagement.accounts.form.editTitle": "Modifica conto",
  "timeManagement.accounts.form.fields.accountKind": "Tipo di conto",
  "timeManagement.accounts.form.fields.allowsManualBooking": "Registrazione manuale consentita",
  "timeManagement.accounts.form.fields.allowsNegativeBalance": "Saldo negativo consentito",
  "timeManagement.accounts.form.fields.shownInSpecialBookings": "Mostra in «Registrazioni particolari»",
  "timeManagement.accounts.form.fields.code": "Codice",
  "timeManagement.accounts.form.fields.codePlaceholder": "es. STRAORDINARI_50",
  "timeManagement.accounts.form.fields.displayFormat": "Formato di visualizzazione",
  "timeManagement.accounts.form.fields.displayFormatHelp": "Solo visualizzazione — non cambia come viene memorizzato il saldo.",
  "timeManagement.accounts.form.fields.displayFormatNone": "Nessun formato",
  "timeManagement.accounts.form.fields.name": "Denominazione",
  "timeManagement.accounts.form.fields.negativeLimit": "Limite inferiore (opzionale)",
  "timeManagement.accounts.form.fields.valueType": "Tipo di valore",
  "timeManagement.accounts.form.overrideTitle": "Sovrascrivi conto",
  "timeManagement.accounts.form.validation.codeMaxLength": "Il codice è troppo lungo.",
  "timeManagement.accounts.form.validation.codeRequired": "Il codice è obbligatorio.",
  "timeManagement.accounts.form.validation.nameMaxLength": "La denominazione è troppo lunga.",
  "timeManagement.accounts.form.validation.nameRequired": "La denominazione è obbligatoria.",
  "timeManagement.accounts.form.validation.validFromRequired": "Valido da è obbligatorio.",
  "timeManagement.accounts.kind.COUNTER": "Contatore",
  "timeManagement.accounts.kind.ENTITLEMENT": "Diritto",
  "timeManagement.accounts.kind.TIME": "Conto tempo",
  "timeManagement.accounts.list.empty": "Nessun conto presente.",
  "timeManagement.accounts.list.manualBooking": "registrazione manuale",
  "timeManagement.accounts.list.hiddenFromSpecialBookings": "non nelle registrazioni particolari",
  "timeManagement.accounts.list.noNegative": "nessun saldo negativo",
  "timeManagement.accounts.valueType.COUNTER": "Contatore",
  "timeManagement.accounts.valueType.DAYS": "Giorni",
  "timeManagement.accounts.valueType.MINUTES": "Minuti",
  "timeManagement.accounts.valueType.NUMBER": "Numero",
  "timeManagement.bookingTypes.actions.create": "Crea tipo di timbratura",
  "timeManagement.bookingTypes.delete.confirm": "Vuoi davvero eliminare questo tipo di timbratura?",
  "timeManagement.bookingTypes.directionHint.END": "Fine",
  "timeManagement.bookingTypes.directionHint.NEUTRAL": "Neutro",
  "timeManagement.bookingTypes.directionHint.START": "Inizio",
  "timeManagement.bookingTypes.errors.loadFailed": "Impossibile caricare i tipi di timbratura.",
  "timeManagement.bookingTypes.form.createTitle": "Nuovo tipo di timbratura",
  "timeManagement.bookingTypes.form.editTitle": "Modifica tipo di timbratura",
  "timeManagement.bookingTypes.form.fields.code": "Codice",
  "timeManagement.bookingTypes.form.fields.codePlaceholder": "es. ENTRATA",
  "timeManagement.bookingTypes.form.fields.directionHint": "Direzione (solo UI)",
  "timeManagement.bookingTypes.form.fields.directionHintHelp": "Solo un suggerimento di visualizzazione — l’abbinamento inizio/fine è deciso dal set di regole.",
  "timeManagement.bookingTypes.form.fields.directionHintNone": "Nessun suggerimento",
  "timeManagement.bookingTypes.form.fields.isRealBooking": "Timbratura reale (non un marcatore di sistema)",
  "timeManagement.bookingTypes.form.fields.name": "Denominazione",
  "timeManagement.bookingTypes.form.overrideTitle": "Sovrascrivi tipo di timbratura",
  "timeManagement.bookingTypes.form.validation.codeMaxLength": "Il codice è troppo lungo.",
  "timeManagement.bookingTypes.form.validation.codeRequired": "Il codice è obbligatorio.",
  "timeManagement.bookingTypes.form.validation.nameMaxLength": "La denominazione è troppo lunga.",
  "timeManagement.bookingTypes.form.validation.nameRequired": "La denominazione è obbligatoria.",
  "timeManagement.bookingTypes.form.validation.validFromRequired": "Valido da è obbligatorio.",
  "timeManagement.bookingTypes.list.empty": "Nessun tipo di timbratura presente.",
  "timeManagement.bookingTypes.list.systemMarker": "marcatore di sistema",
  "timeManagement.common.inheritedFrom": "ereditato da {{unit}}",
  "timeManagement.common.overridden": "sovrascritto",
  "timeManagement.common.override": "Sovrascrivi qui",
  "timeManagement.common.restore": "Rimuovi la versione locale (torna ereditata)",
  "timeManagement.common.saving": "Salvataggio …",
  "timeManagement.common.validFrom": "Valido da",
  "timeManagement.common.validTo": "Valido fino a",
  "timeManagement.common.validUntil": "fino al {{date}}",
  "timeManagement.dayPrograms.actions.create": "Nuovo programma giornaliero",
  "timeManagement.dayPrograms.delete.confirm": "Eliminare questo programma giornaliero?",
  "timeManagement.dayPrograms.errors.loadFailed": "Non è stato possibile caricare i programmi giornalieri.",
  "timeManagement.dayPrograms.form.coreTime.add": "Aggiungi fascia obbligatoria",
  "timeManagement.dayPrograms.form.coreTime.empty": "Per questo giorno non è definita alcuna fascia obbligatoria.",
  "timeManagement.dayPrograms.form.coreTime.endsNextDay": "termina il giorno dopo",
  "timeManagement.dayPrograms.form.coreTime.from": "dalle",
  "timeManagement.dayPrograms.form.coreTime.hint": "La fascia in cui è richiesta la presenza. Vale per ogni giorno della settimana che usa questo programma giornaliero.",
  "timeManagement.dayPrograms.form.coreTime.problem.incomplete": "Indicare inizio e fine della fascia obbligatoria.",
  "timeManagement.dayPrograms.form.coreTime.problem.notForward": "La fascia obbligatoria deve terminare dopo il suo inizio.",
  "timeManagement.dayPrograms.form.coreTime.problem.overlap": "Due fasce obbligatorie non possono coprire lo stesso minuto. Una può iniziare dove finisce l’altra.",
  "timeManagement.dayPrograms.form.coreTime.remove": "Rimuovi fascia obbligatoria",
  "timeManagement.dayPrograms.form.coreTime.title": "Fascia obbligatoria",
  "timeManagement.dayPrograms.form.coreTime.to": "alle",
  "timeManagement.dayPrograms.form.createTitle": "Nuovo programma giornaliero",
  "timeManagement.dayPrograms.form.editTitle": "Modifica programma giornaliero",
  "timeManagement.dayPrograms.form.fields.code": "Codice",
  "timeManagement.dayPrograms.form.fields.codePlaceholder": "NORMAL",
  "timeManagement.dayPrograms.form.fields.name": "Denominazione",
  "timeManagement.dayPrograms.form.fields.targetMinutes": "Minuti obiettivo",
  "timeManagement.dayPrograms.form.fields.targetMinutesHint": "Lasciare vuoto per sommare gli intervalli.",
  "timeManagement.dayPrograms.form.fields.validFrom": "Valido dal",
  "timeManagement.dayPrograms.form.fields.validTo": "Valido fino al",
  "timeManagement.dayPrograms.form.intervals.add": "Aggiungi intervallo",
  "timeManagement.dayPrograms.form.intervals.chooseKind": "Seleziona…",
  "timeManagement.dayPrograms.form.intervals.empty": "Nessun intervallo. Senza di essi la giornata non ha uno svolgimento pianificato.",
  "timeManagement.dayPrograms.form.intervals.end": "Alle",
  "timeManagement.dayPrograms.form.intervals.endsNextDay": "Termina il giorno seguente",
  "timeManagement.dayPrograms.form.intervals.errors.endBeforeStart": "La fine non è successiva all’inizio. Per un turno notturno spunta «termina il giorno seguente».",
  "timeManagement.dayPrograms.form.intervals.errors.overlaps": "Questo intervallo si sovrappone a uno precedente. Due intervalli dello stesso programma giornaliero non possono coprire due volte lo stesso minuto — ma uno può terminare esattamente dove inizia il successivo.",
  "timeManagement.dayPrograms.form.intervals.kind": "Tipo",
  "timeManagement.dayPrograms.form.intervals.moveDown": "Sposta giù",
  "timeManagement.dayPrograms.form.intervals.moveUp": "Sposta su",
  "timeManagement.dayPrograms.form.intervals.remove": "Rimuovi",
  "timeManagement.dayPrograms.form.intervals.spans": "dura {{minutes}} min",
  "timeManagement.dayPrograms.form.intervals.start": "Dalle",
  "timeManagement.dayPrograms.form.intervals.targetMinutes": "Conta come (min)",
  "timeManagement.dayPrograms.form.intervals.title": "Intervalli",
  "timeManagement.dayPrograms.form.overrideTitle": "Sovrascrivi programma giornaliero",
  "timeManagement.dayPrograms.form.saving": "Salvataggio…",
  "timeManagement.dayPrograms.form.validation.codeMaxLength": "Il codice può avere al massimo 50 caratteri.",
  "timeManagement.dayPrograms.form.validation.codeRequired": "Inserisci un codice.",
  "timeManagement.dayPrograms.form.validation.nameMaxLength": "La denominazione può avere al massimo 255 caratteri.",
  "timeManagement.dayPrograms.form.validation.nameRequired": "Inserisci una denominazione.",
  "timeManagement.dayPrograms.form.validation.validFromRequired": "Inserisci l'inizio della validità.",
  "timeManagement.dayPrograms.list.empty": "Questa unità non ha ancora programmi giornalieri.",
  "timeManagement.dayPrograms.list.target": "Obiettivo {{minutes}} min",
  "timeManagement.dayPrograms.list.targetFromIntervals": "Obiettivo dagli intervalli",
  "timeManagement.publicHolidays.actions.create": "Aggiungi festività",
  "timeManagement.publicHolidays.calendar.empty": "In quest'anno nessuna festività ricade su questa unità.",
  "timeManagement.publicHolidays.calendar.title": "Calendario {{year}}",
  "timeManagement.publicHolidays.calendar.previousYear": "Anno precedente",
  "timeManagement.publicHolidays.calendar.nextYear": "Anno successivo",
  "timeManagement.publicHolidays.delete.confirm": "Eliminare davvero questa festività?",
  "timeManagement.publicHolidays.errors.loadFailed": "Non è stato possibile caricare le festività.",
  "timeManagement.publicHolidays.form.createTitle": "Aggiungi festività",
  "timeManagement.publicHolidays.form.editTitle": "Modifica festività",
  "timeManagement.publicHolidays.form.fields.code": "Codice",
  "timeManagement.publicHolidays.form.fields.countries": "Vale in questi paesi",
  "timeManagement.publicHolidays.form.fields.dayOfMonth": "Giorno",
  "timeManagement.publicHolidays.form.fields.kind": "Come si determina la data",
  "timeManagement.publicHolidays.form.fields.monthOfYear": "Mese",
  "timeManagement.publicHolidays.form.fields.name": "Denominazione",
  "timeManagement.publicHolidays.form.fields.offsetDays": "Giorni dalla domenica di Pasqua",
  "timeManagement.publicHolidays.form.fields.singleDate": "Data",
  "timeManagement.publicHolidays.form.fields.validFrom": "Valido dal",
  "timeManagement.publicHolidays.form.fields.validTo": "Valido fino al",
  "timeManagement.publicHolidays.form.hints.countries": "Solo i paesi presenti nell’organigramma. Mezza giornata significa metà del dovuto, senza collocazione.",
  "timeManagement.publicHolidays.form.hints.noCountries": "Nell’organigramma non è ancora impostato alcun paese. Impostane uno sull’azienda o sulla radice.",
  "timeManagement.publicHolidays.form.hints.offsetDays": "Negativo precede la Pasqua: Venerdì santo −2, Lunedì dell'Angelo 1, Corpus Domini 60.",
  "timeManagement.publicHolidays.form.hints.singleDate": "L’unica data in cui cade questa festività. Non si ripete.",
  "timeManagement.publicHolidays.form.hints.validity": "Quando la festività esiste, non quando cade. Vuoto significa senza scadenza.",
  "timeManagement.publicHolidays.form.overrideTitle": "Sovrascrivi festività",
  "timeManagement.publicHolidays.form.validation.codeMaxLength": "Il codice può avere al massimo 50 caratteri.",
  "timeManagement.publicHolidays.form.validation.codeRequired": "Il codice è obbligatorio.",
  "timeManagement.publicHolidays.form.validation.countryNone": "Scegli almeno un paese — altrimenti la festività non vale da nessuna parte.",
  "timeManagement.publicHolidays.form.validation.dateNeverOccurs": "Questo giorno non esiste in nessun anno.",
  "timeManagement.publicHolidays.form.validation.dayOutOfRange": "Il giorno deve essere compreso tra 1 e 31.",
  "timeManagement.publicHolidays.form.validation.easterNeedsOffset": "Una festività calcolata dalla Pasqua richiede uno scostamento.",
  "timeManagement.publicHolidays.form.validation.easterTakesNoDate": "Una festività calcolata dalla Pasqua non ha data fissa.",
  "timeManagement.publicHolidays.form.validation.fixedNeedsDate": "Una festività a data fissa richiede mese e giorno.",
  "timeManagement.publicHolidays.form.validation.fixedTakesNoOffset": "Una festività a data fissa non ha scostamento dalla Pasqua.",
  "timeManagement.publicHolidays.form.validation.monthOutOfRange": "Il mese deve essere compreso tra 1 e 12.",
  "timeManagement.publicHolidays.form.validation.nameMaxLength": "La denominazione può avere al massimo 255 caratteri.",
  "timeManagement.publicHolidays.form.validation.nameRequired": "La denominazione è obbligatoria.",
  "timeManagement.publicHolidays.form.validation.offsetOutOfRange": "Lo scostamento è troppo grande per una festività mobile.",
  "timeManagement.publicHolidays.form.validation.recurringTakesNoSingleDate": "Una festività ricorrente non porta una data singola.",
  "timeManagement.publicHolidays.form.validation.singleDateMalformed": "Deve essere un giorno reale, come AAAA-MM-GG.",
  "timeManagement.publicHolidays.form.validation.singleNeedsDate": "Una festività una tantum ha bisogno della sua data.",
  "timeManagement.publicHolidays.form.validation.singleTakesNoRule": "Una festività una tantum non porta né mese e giorno né uno scarto dalla Pasqua.",
  "timeManagement.publicHolidays.form.validation.validFromRequired": "L'inizio della validità è obbligatorio.",
  "timeManagement.publicHolidays.kinds.EASTER_OFFSET": "Calcolata dalla Pasqua",
  "timeManagement.publicHolidays.kinds.FIXED": "Data fissa",
  "timeManagement.publicHolidays.kinds.SINGLE_DATE": "Una tantum",
  "timeManagement.publicHolidays.list.definitionsTitle": "Festività",
  "timeManagement.publicHolidays.tabs.calendar": "Calendario",
  "timeManagement.publicHolidays.tabs.list": "Festività",
  "timeManagement.publicHolidays.list.empty": "Per questa unità non è ancora stata definita alcuna festività.",
  "timeManagement.publicHolidays.observances.FULL": "Intera",
  "timeManagement.publicHolidays.observances.HALF": "Metà",
  "timeManagement.timeTypes.actions.create": "Crea tipo di tempo",
  "timeManagement.timeTypes.delete.confirm": "Vuoi davvero eliminare questo tipo di tempo?",
  "timeManagement.timeTypes.errors.loadFailed": "Impossibile caricare i tipi di tempo.",
  "timeManagement.timeTypes.form.createTitle": "Nuovo tipo di tempo",
  "timeManagement.timeTypes.form.editTitle": "Modifica tipo di tempo",
  "timeManagement.timeTypes.form.fields.category": "Categoria",
  "timeManagement.timeTypes.form.fields.categoryPlaceholder": "Seleziona …",
  "timeManagement.timeTypes.form.fields.code": "Codice",
  "timeManagement.timeTypes.form.fields.displayOrder": "Ordine di visualizzazione (opzionale)",
  "timeManagement.timeTypes.form.fields.evaluationPriority": "Precedenza",
  "timeManagement.timeTypes.form.fields.evaluationPriorityHint": "In caso di sovrapposizione nello stesso giorno prevale il numero più alto. 0 significa nessuna precedenza.",
  "timeManagement.timeTypes.form.fields.name": "Denominazione",
  "timeManagement.timeTypes.form.fields.workTimeCreditMode": "Accredito sul tempo target",
  "timeManagement.timeTypes.form.fields.workTimeCreditModeHint": "Come un segmento di questo tipo viene conteggiato sul tempo target.",
  "timeManagement.timeTypes.form.fields.workTimeCreditModePlaceholder": "Seleziona modalità di accredito",
  "timeManagement.timeTypes.form.overrideTitle": "Sovrascrivi tipo di tempo",
  "timeManagement.timeTypes.form.validation.categoryRequired": "La categoria è obbligatoria.",
  "timeManagement.timeTypes.form.validation.codeMaxLength": "Il codice è troppo lungo.",
  "timeManagement.timeTypes.form.validation.codeRequired": "Il codice è obbligatorio.",
  "timeManagement.timeTypes.form.validation.creditModeRequired": "La modalità di accredito è obbligatoria",
  "timeManagement.timeTypes.form.validation.nameMaxLength": "La denominazione è troppo lunga.",
  "timeManagement.timeTypes.form.validation.nameRequired": "La denominazione è obbligatoria.",
  "timeManagement.timeTypes.form.validation.validFromRequired": "Valido da è obbligatorio.",
  "timeManagement.timeTypes.list.empty": "Nessun tipo di tempo presente.",
  "timeManagement.timeTypes.list.priority": "precedenza {{value}}",
  "timeManagement.workSchedules.actions.create": "Nuovo modello orario",
  "timeManagement.workSchedules.delete.confirm": "Eliminare questo modello orario?",
  "timeManagement.workSchedules.errors.loadFailed": "Non è stato possibile caricare i modelli orari.",
  "timeManagement.workSchedules.form.coreTime.add": "+ Fascia obbligatoria",
  "timeManagement.workSchedules.form.coreTime.endsNextDay": "termina il giorno dopo",
  "timeManagement.workSchedules.form.coreTime.from": "Fascia obbligatoria dalle",
  "timeManagement.workSchedules.form.coreTime.hint": "Facoltativo per giorno: la fascia di presenza obbligatoria.",
  "timeManagement.workSchedules.form.coreTime.problems.incomplete": "Una fascia obbligatoria richiede inizio e fine.",
  "timeManagement.workSchedules.form.coreTime.problems.notForward": "La fascia deve terminare dopo il suo inizio — oltre la mezzanotte spuntare «termina il giorno dopo».",
  "timeManagement.workSchedules.form.coreTime.problems.overlap": "Due fasce dello stesso giorno si sovrappongono. Una può terminare esattamente dove inizia la successiva.",
  "timeManagement.workSchedules.form.coreTime.remove": "Rimuovi la fascia obbligatoria",
  "timeManagement.workSchedules.form.coreTime.to": "alle",
  "timeManagement.workSchedules.form.createTitle": "Nuovo modello orario",
  "timeManagement.workSchedules.form.editTitle": "Modifica modello orario",
  "timeManagement.workSchedules.form.fields.code": "Codice",
  "timeManagement.workSchedules.form.fields.codePlaceholder": "STANDARD",
  "timeManagement.workSchedules.form.fields.cycleWeeks": "Ciclo (settimane)",
  "timeManagement.workSchedules.form.fields.cycleWeeksHint": "1 significa ogni settimana uguale. Più settimane danno uno schema rotativo.",
  "timeManagement.workSchedules.form.fields.name": "Denominazione",
  "timeManagement.workSchedules.form.fields.validFrom": "Valido dal",
  "timeManagement.workSchedules.form.fields.validTo": "Valido fino al",
  "timeManagement.workSchedules.form.grid.dayOff": "— libero —",
  "timeManagement.workSchedules.form.grid.dayProgramsFailed": "Non è stato possibile caricare i programmi giornalieri. Lo schema settimanale può essere compilato solo quando l’operazione riesce.",
  "timeManagement.workSchedules.form.grid.noDayPrograms": "Questa unità non ha ancora un programma giornaliero, nemmeno ereditato. I programmi giornalieri si ereditano verso il basso, non verso l’alto: uno su un’unità inferiore non conta qui. Creane prima uno su questa unità o su una superiore.",
  "timeManagement.workSchedules.form.grid.title": "Schema settimanale",
  "timeManagement.workSchedules.form.grid.unreadableCycle": "Inserisci un ciclo tra 1 e 52 settimane per vedere lo schema.",
  "timeManagement.workSchedules.form.grid.week": "Settimana {{week}}",
  "timeManagement.workSchedules.form.overrideTitle": "Sovrascrivi modello orario",
  "timeManagement.workSchedules.form.problems.coreTime": "Almeno una fascia obbligatoria è incompleta o si sovrappone — vedere il giorno segnalato.",
  "timeManagement.workSchedules.form.problems.cycleWeeks": "Il ciclo deve essere un numero intero tra 1 e 52 settimane.",
  "timeManagement.workSchedules.form.problems.noDays": "Assegna un programma giornaliero ad almeno un giorno, altrimenti questo modello non pianifica nulla.",
  "timeManagement.workSchedules.form.saving": "Salvataggio…",
  "timeManagement.workSchedules.form.validation.codeMaxLength": "Il codice può avere al massimo 50 caratteri.",
  "timeManagement.workSchedules.form.validation.codeRequired": "Inserisci un codice.",
  "timeManagement.workSchedules.form.validation.nameMaxLength": "La denominazione può avere al massimo 255 caratteri.",
  "timeManagement.workSchedules.form.validation.nameRequired": "Inserisci una denominazione.",
  "timeManagement.workSchedules.form.validation.validFromRequired": "Inserisci l'inizio della validità.",
  "timeManagement.workSchedules.list.cycle": "Ciclo di {{weeks}} settimana/e",
  "timeManagement.workSchedules.list.empty": "Questa unità non ha ancora modelli orari.",
  "timeManagement.workSchedules.weekday.1": "Lunedì",
  "timeManagement.workSchedules.weekday.2": "Martedì",
  "timeManagement.workSchedules.weekday.3": "Mercoledì",
  "timeManagement.workSchedules.weekday.4": "Giovedì",
  "timeManagement.workSchedules.weekday.5": "Venerdì",
  "timeManagement.workSchedules.weekday.6": "Sabato",
  "timeManagement.workSchedules.weekday.7": "Domenica",
  "timeTracking.correct": "Correggi",
  "timeTracking.corrected": "corretta",
  "timeTracking.countingStamps": "{{count}} timbrature valide",
  "timeTracking.employment": "Rapporto di lavoro",
  "timeTracking.empty": "In questo intervallo non è stato registrato nulla.",
  "timeTracking.errors.actionFailed": "Impossibile salvare la timbratura.",
  "timeTracking.errors.loadFailed": "Impossibile caricare le timbrature.",
  "timeTracking.errors.rangeOrder": "La fine non può precedere l’inizio.",
  "timeTracking.form.abortCorrection": "Annulla correzione",
  "timeTracking.form.bookingType": "Tipo di timbratura",
  "timeTracking.form.chooseBookingType": "Seleziona",
  "timeTracking.form.correcting": "Correzione della timbratura delle {{time}}",
  "timeTracking.form.date": "Data",
  "timeTracking.form.hint": "Nulla viene sovrascritto: il ritiro imposta uno stato, la correzione scrive una nuova timbratura che rimanda alla precedente. Un giorno chiuso viene rifiutato.",
  "timeTracking.form.reason": "Motivazione",
  "timeTracking.form.record": "Registra",
  "timeTracking.form.time": "Ora",
  "timeTracking.form.title": "Registra una timbratura",
  "timeTracking.from": "Da",
  "timeTracking.isCorrection": "correzione",
  "timeTracking.organizationUnit": "Unità organizzativa",
  "timeTracking.showWithdrawn": "Mostra ritirate",
  "timeTracking.to": "A",
  "timeTracking.withdraw": "Ritira",
  "timeTracking.withdrawn": "ritirata",
  "employmentPicker.placeholder": "Nome, matricola o numero di contratto",
  "employmentPicker.empty": "Nessun rapporto di lavoro trovato",
  "employmentPicker.loading": "Ricerca …",
  "employmentPicker.more": "Altri risultati – affinare la ricerca",
  "employmentPicker.personnelNumber": "Matr. {{number}}",
  "employmentPicker.allUnits": "Tutte le unità",
  "employmentPicker.unitPlaceholder": "Cerca unità",
  "employmentPicker.noUnit": "Nessuna unità trovata",
  "timeTracking.form.noBookingType": "Nessun tipo di timbratura trovato",
  "nav.secondary.persons.employments": "Rapporti di lavoro",
  "persons.list.tabs.employments": "Rapporti di lavoro",
  "employments.directory.subtitle": "Tutti i rapporti di lavoro del mandante – per nome, matricola o numero di contratto.",
  "employments.directory.back": "Torna all’elenco",
  "employments.directory.company": "Azienda",
  "employments.directory.chooseCompany": "Scegli azienda",
  "employments.directory.noCompany": "Questo mandante non ha un’azienda su cui creare un rapporto di lavoro.",
  "employments.directory.search": "Ricerca",
  "employments.directory.empty": "Questo mandante non ha ancora rapporti di lavoro.",
  "employments.directory.personnelNumber": "Matricola",
  "employments.directory.state": "Stato",
  "employments.directory.actions": "Azioni",
  "employments.directory.more": "Carica altri",
  "employments.state.ACTIVE": "attivo",
  "employments.state.UPCOMING": "futuro",
  "employments.state.ENDED": "concluso",
  "employments.person.none": "Questa persona non ha rapporti di lavoro visibili per lei.",
  "employments.person.open": "Apri",
  "employments.person.tracking": "Rilevazione tempo",
  "employments.person.account": "Conto ore",
  "persons.list.search": "Ricerca",
  "persons.list.searchPlaceholder": "Nome, parte del nome o matricola",
  "persons.list.columns.personnelNumber": "Matricola",
  "processing.closing.incomplete": "Elaborazione incompleta: {{count}} lacuna/e – la chiusura resta bloccata.",
  "processing.closing.moreGaps": "… e altre {{count}}",
  "processing.closing.gap.NEVER_COMPUTED": "mai elaborato",
  "processing.closing.gap.FAILED": "errore di elaborazione",
  "processing.closing.gap.DEPENDENT": "saltato perché un giorno precedente è fallito",
  "processing.closing.gap.RUN_FAILED": "l’elaborazione è fallita nel suo complesso",
  "processing.closing.gap.NO_RULE_SET": "nessun regolamento assegnato",
  "processing.closing.gap.NO_WORK_SCHEDULE": "nessun modello orario",
  "processing.closing.gap.INPUT_CHANGED": "timbrature modificate dopo l’elaborazione"
}
